import React from 'react';
import {connect} from "react-redux";
import * as go from 'gojs';
import {
    createBOCLayout,
    deleteBOCLayout,
    fetchAllBOCLayouts,
    fetchBOCLayoutById,
    layoutSaveObjects,
    setCurrentBOCLayout,
    setHiddenAndModifiedBOCs,
    updateBOCLayout
} from "../../actions/boCoreActions";
import {setTitle} from '../../actions/topHeaderActions';
import {Inspector} from "../../gojs/DataInspector";
import * as HyperlinkText from "../../gojs/HyperlinkText";
import LayoutBusinessObjectsGrid from "../../components/bo-core/grids/LayoutBusinessObjectsGrid";
import * as toastr from "toastr";
import {DataTypesEnum} from "../../components/bo-core/enums/dataTypesEnum";
import BusinessObjects from "./BusinessObjects";
import {EVENTS, GOJS_SELECT_CHOICES, LAYOUT_OBJECT_STATES, LAYOUT_OBJECT_TYPES} from "../../config/boCore";
import {FilterXSS} from "xss";

let myDiagram = null;
let nodes = [];
let links = [];
let confirm = null;
let allowUpdate = true;
let showLabels = true;
let showSysObjects = true;
let autoCurrentLayout = false;
let fullLayout = null;
let objectsChanged = false;
let systemObjectsToggle = false;
let selectedVal = JSON.stringify({id: -1, name: "Full diagram (auto)"});
let bocToSave = {bocToAdd: [], bocToDelete: [], bocToUpdate: []};
let relToSave = {relToAdd: [], relToDelete: [], relToUpdate: []};
const shortid = require("shortid");
const myxss = new FilterXSS({
    whiteList: {}
});

require("../../gojs/Figures");


class BusinessObjectsLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedHidden: null
        };
        this.autoLayout = this.autoLayout.bind(this);
        this.saveObjects = this.saveObjects.bind(this);
        this.saveDiagram = this.saveDiagram.bind(this);
        this.deleteLayout = this.deleteLayout.bind(this);
        this.toggleLabels = this.toggleLabels.bind(this);
        this.toggleSysObjects = this.toggleSysObjects.bind(this);
    }

   UNSAFE_componentWillMount() {
        $(document.body)
            .unbind(EVENTS.boView.objectsLayout.open)
            .unbind(EVENTS.boView.objectsLayout.create)
            .unbind(EVENTS.boView.objectsLayout.update)
            .unbind(EVENTS.boView.objectsLayout.delete)
            .unbind(EVENTS.boView.objectsLayout.saveObjects)
            .unbind(EVENTS.boView.objectsLayout.hidden)
            .unbind(EVENTS.boView.objectsLayout.fetchAll)
            .on(EVENTS.boView.objectsLayout.hidden, (event) => {
                event.preventDefault();
                allowUpdate = false;
            })
            .on(EVENTS.boView.objectsLayout.open, (event) => {
                this.resetDefaults();
                this.props.fetchAllBOCLayouts();
                event.preventDefault();
            })
            .on(EVENTS.boView.objectsLayout.saveObjects, (event) => {
                this.resetDefaults();
                autoCurrentLayout = false;
                this.init(event.args.businessObjectsWrapper, this.props.currentLayout);
                event.preventDefault();
            })
            .on(EVENTS.boView.objectsLayout.create, (event) => {
                this.resetDefaults();
                this.init(this.props.businessObjectsWrapper, event.args.currentLayout);
                event.preventDefault();
            })
            .on(EVENTS.boView.objectsLayout.update, (event) => {
                this.resetDefaults();
                this.init(this.props.businessObjectsWrapper, event.args.currentLayout);
                event.preventDefault();
            })
            .on(EVENTS.boView.objectsLayout.delete, (event) => {
                this.resetDefaults();
                this.init(this.props.businessObjectsWrapper, this.props.currentLayout);
                event.preventDefault();
            })
            .on(EVENTS.boView.objectsLayout.fetchAll, (event) => {
                this.resetDefaults();
                this.init(this.props.businessObjectsWrapper, this.props.currentLayout);
                event.preventDefault();
            })
        ;
    }

    componentDidMount() {
        $('#layout-info-popover').popover({
            placement: 'left',
            html: true,
            title: 'Information',
            content: function () {
                return $('#popover-content').html();
            }
        }).data('bs.popover')
            .tip()
            .addClass('layout-info-popover');
        $('body').on('click', function (e) {
            $('#layout-info-popover').each(function () {
                if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                    $(this).popover('hide');
                    if ($('#layout-info-popover').hasClass("active")) {
                        $('#layout-info-popover')
                            .click()
                            .removeClass("active");
                    }
                }
            });
        });

        if (myDiagram != null) {
            myDiagram = null;
        }
        objectsChanged = false;
    }

    shouldComponentUpdate() {
        return allowUpdate;
    }

    componentDidUpdate() {
        if (this.props.businessObjectsWrapper != undefined && this.props.businessObjectsWrapper != null) {
            this.resetDefaults();
            this.init(this.props.businessObjectsWrapper, this.props.currentLayout);
        }
    }

    resetDefaults() {
        if (myDiagram != null) {
            myDiagram.div = null;
        }
        myDiagram = null;
        nodes = [];
        links = [];
        objectsChanged = false;
        showSysObjects = true;
        showLabels = true;
        jQuery("#toggle_sys_objects_btn").html("<i class='fas fa-toggle-on fa-sm'/><span> Hide System Objects</span>");
        jQuery("#toggle_link_labels_diagram_btn").html("<i class='fas fa-toggle-on fa-sm'/><span> Hide Link Labels</span>");
        fullLayout = null;
    }

    updateSelected(data) {
        allowUpdate = false;
        this.setState({selectedHidden: data});
    }

    autoLayout() {
        if (myDiagram != null) {
            myDiagram.div = null;
        }
        autoCurrentLayout = true;

        this.init(this.props.businessObjectsWrapper, this.props.currentLayout);
    }

    init = (businessObjectsWrapper, currentLayout, {allLayouts, currentBusinessObject, hiddenAndModifiedBOCsForLayout} = this.props) => {
        let layoutsList = [];
        let changedNodes = [];
        let unchangedNodes = [];
        if (allLayouts != null) {
            layoutsList = Array.from(allLayouts.values()).sort((a, b) => a.name.localeCompare(b.name));
        }

        const self = this;
        let $selectParent = jQuery("#custom-select");
        $selectParent.empty();
        let $select = jQuery("<select id='layout_select' style='outline:none!important; width:200px;'/>");
        $select.appendTo($selectParent);
        PopulateLayoutsSelect($select[0], layoutsList);

        $select.select2({
            placeholder: "Select Layout",
            theme: "classic",
        });

        if (currentLayout != null) {
            selectedVal = JSON.stringify({id: currentLayout.id, name: currentLayout.name});
        } else {
            jQuery('#delete_layout_btn').prop("disabled", true);
        }

        jQuery('#layout_select').val(selectedVal).trigger("change").off("change").on("change", (e) => {
            if (JSON.parse(e.currentTarget.value).id !== -1) {
                jQuery('#delete_layout_btn').prop("disabled", false);
                selectedVal = e.currentTarget.value;
                if (currentLayout != null) {
                    if (JSON.parse(selectedVal).id != currentLayout.id) {
                        links = [];
                        nodes = [];
                        fullLayout = null;
                        setTimeout(() => {
                            allowUpdate = true;
                            this.props.fetchBOCLayoutById(JSON.parse(selectedVal).id);
                        }, 1);
                    } else {
                        changedNodes.length = 0;
                        links = [];
                        nodes = [];
                        allowUpdate = false;
                        self.props.setHiddenAndModifiedBOCsForLayout([]);
                        setTimeout(() => {
                            allowUpdate = true;
                            this.props.fetchBOCLayoutById(JSON.parse(selectedVal).id);
                        }, 1);
                    }
                } else {
                    links = [];
                    nodes = [];
                    setTimeout(() => {
                        allowUpdate = true;
                        this.props.fetchBOCLayoutById(JSON.parse(selectedVal).id);
                    }, 1);
                }
            } else {
                jQuery('#delete_layout_btn').prop("disabled", true);
                selectedVal = JSON.stringify({id: -1, name: "Full diagram (auto)"});
                changedNodes.length = 0;
                links = [];
                nodes = [];
                allowUpdate = false;
                self.props.setHiddenAndModifiedBOCsForLayout(Array.from(changedNodes));
                setTimeout(() => {
                    allowUpdate = true;
                    this.props.setCurrentBOCLayout(null);
                }, 1);
            }
        });

        let $ = go.GraphObject.make;  // for conciseness in defining templates
        if (myDiagram != null) {
            myDiagram.div = null;
        }

        if (currentLayout == null || autoCurrentLayout) {
            myDiagram =
                $(go.Diagram, "myDiagramDiv",  // must name or refer to the DIV HTML element
                    {
                        initialAutoScale: go.Diagram.Uniform,  // an initial automatic zoom-to-fit
                        contentAlignment: go.Spot.Center,  // align document to the center of the viewport
                        "linkingTool.isEnabled": false,  // invoked explicitly by drawLink function, below
                        "linkingTool.direction": go.LinkingTool.ForwardsOnly,  // only draw "from" towards "to"
                        "undoManager.isEnabled": true,  // enable undo & redo
                        "clickCreatingTool.archetypeNodeData": {},
                        layout:
                            $(go.ForceDirectedLayout,  // automatically spread nodes apart
                                {
                                    defaultSpringLength: 100,
                                    defaultElectricalCharge: 150,
                                    arrangementSpacing: new go.Size(150, 150),
                                }),
                        "clickCreatingTool.insertPart": createNode,
                        "SelectionDeleting": hideNode,
                        "ChangedSelection": selectionChanged,
                        "InitialLayoutCompleted": initialLayoutCompleted,
                        "LayoutCompleted": initialLayoutCompleted,
                        maxSelectionCount: 1
                    });
        } else {
            myDiagram =
                $(go.Diagram, "myDiagramDiv",  // must name or refer to the DIV HTML element
                    {
                        initialAutoScale: go.Diagram.Uniform,  // an initial automatic zoom-to-fit
                        contentAlignment: go.Spot.Center,  // align document to the center of the viewport
                        "linkingTool.isEnabled": false,  // invoked explicitly by drawLink function, below
                        "linkingTool.direction": go.LinkingTool.ForwardsOnly,  // only draw "from" towards "to"
                        "undoManager.isEnabled": true,  // enable undo & redo
                        "clickCreatingTool.archetypeNodeData": {},
                        "clickCreatingTool.insertPart": createNode,
                        "SelectionDeleting": hideNode,
                        "ChangedSelection": selectionChanged,
                        "InitialLayoutCompleted": initialLayoutCompleted,
                        "LayoutCompleted": initialLayoutCompleted,
                        maxSelectionCount: 1
                    });
        }

        function modifyNodesAndLinks(diagramNodes, nodeDataArray, diagramLinks, linkDataArray) {
            let modifiedNodes = diagramNodes.filter(s => nodeDataArray.find(x => x.key == s.key &&
                (x.name != s.name || x.description != s.description || x.color != s.color || x.fontColor != s.fontColor
                    || x.shape != s.shape || x.location != s.location || x.angle != s.angle
                    || (x.width != s.width && s.width != null) || (x.height != s.height && s.height != null))) != null);
            modifiedNodes.forEach(node => {
                let nNode = nodes.find(s => s.key == node.key);
                if (nNode != null) {
                    nNode.name = node.name;
                    nNode.description = node.description;
                    nNode.color = node.color;
                    nNode.fontColor = node.fontColor;
                    nNode.shape = node.shape;
                    nNode.angle = node.angle;
                    nNode.location = node.location;
                    nNode.width = node.width;
                    nNode.height = node.height;
                    nNode.isChanged = true;
                    nNode.systemRequired = node.systemRequired;
                }
            });
            let modifiedLinks = diagramLinks.filter(s => linkDataArray.find(x => x.uid == s.uid &&
                (x.relationship_name != s.relationship_name || x.forward != s.forward || x.reverse != s.reverse || x.routing != s.routing)));
            modifiedLinks.forEach(link => {
                let lLink = links.find(s => s.uid == link.uid);
                if (lLink != null) {
                    lLink.relationship_name = link.relationship_name;
                    lLink.forward = link.forward;
                    lLink.reverse = link.reverse;
                    lLink.routing = link.routing;
                    lLink.isChanged = true;
                    lLink.systemRequired = link.systemRequired;
                    lLink.points = link.points;
                }
            });

            if (!compareNodes(changedNodes, hiddenAndModifiedBOCsForLayout)) {
                allowUpdate = false;
                self.props.setHiddenAndModifiedBOCsForLayout(changedNodes);
            }
        }

        myDiagram.addModelChangedListener(function (evt) {
            if (evt.Os == "Undo") {
                let nodeDataArray = Array.from(JSON.parse(JSON.stringify(nodes)));
                let diagramNodes = Array.from(JSON.parse(JSON.stringify(myDiagram.model.nodeDataArray)));
                let unDeletedNodes = nodeDataArray.filter(s => diagramNodes.find(x => x.visible == true && s.visible == false && x.id == s.id) != null);
                unDeletedNodes.forEach(node => {
                    node.visible = true;
                    node.isDeleted = false;
                    nodes.find(s => s.id == node.id).visible = true;
                    nodes.find(s => s.id == node.id).isDeleted = false;
                    let changedIndex = changedNodes.findIndex(s => s.id == node.id && s.type == LAYOUT_OBJECT_TYPES.BO && s.state == LAYOUT_OBJECT_STATES.hidden);
                    if (changedIndex != -1) {
                        let unChangedNode = JSON.parse(JSON.stringify(changedNodes[changedIndex]));
                        unchangedNodes.push(unChangedNode);
                        changedNodes.splice(changedIndex, 1);
                    }
                    if (fullLayout.nodes.findIndex(s => s.id == node.id) == -1) {
                        fullLayout.nodes.push({
                            id: node.id,
                            key: node.key,
                            name: node.name,
                            description: node.description,
                            visible: true,
                            isDeleted: false,
                            color: node.color,
                            shape: node.shape,
                            height: node.height,
                            width: node.width,
                            angle: node.angle,
                            location: node.location,
                            attributes: node.attributes,
                            systemRequired: node.systemRequired,
                            relationships: []
                        });
                    }
                });
                let linkDataArray = Array.from(JSON.parse(JSON.stringify(links)));
                let diagramLinks = Array.from(JSON.parse(JSON.stringify(myDiagram.model.linkDataArray)));
                let undeletedLinks = linkDataArray.filter(s => diagramLinks.find(x => x.visible == true && s.visible == false && x.id == s.id) != null);
                undeletedLinks.forEach(link => {
                    link.visible = true;
                    link.isDeleted = false;
                    if (links.find(s => s.id == link.id) != null) {
                        links.find(s => s.id == link.id).visible = true;
                        links.find(s => s.id == link.id).isDeleted = false;
                    }
                    let changedLinkIndex = changedNodes.findIndex(s => s.id == link.id && s.type == LAYOUT_OBJECT_TYPES.REL && s.state == LAYOUT_OBJECT_STATES.hidden);
                    if (changedLinkIndex != -1) {
                        let unChangedLink = JSON.parse(JSON.stringify(changedNodes[changedLinkIndex]));
                        unchangedNodes.push(unChangedLink);
                        changedNodes.splice(changedLinkIndex, 1);
                    }
                    let nodeIndex = fullLayout.nodes.findIndex(s => s.key == link.from);
                    if (nodeIndex != -1) {
                        if (fullLayout.nodes[nodeIndex].relationships.findIndex(s => s.id == link.id) == -1) {
                            fullLayout.nodes[nodeIndex].relationships.push({
                                id: link.id,
                                relationship_name: link.relationship_name,
                                from: link.from,
                                to: link.to,
                                reverse: link.reverse,
                                forward: link.forward,
                                routing: link.routing,
                                visible: true,
                                labelVisible: showLabels,
                                systemRequired: link.systemRequired,
                                points: link.points
                            });
                        }
                    }
                });

                let unAddedNodes = nodeDataArray.filter(s => diagramNodes.find(x => x.key == s.key) == null && s.id == -1);
                unAddedNodes.forEach(node => {
                    nodes.find(s => s.key == node.key).isAdded = false;
                    let fIndex = fullLayout.nodes.findIndex(s => s.key == node.key);
                    if (fIndex != -1) {
                        fullLayout.nodes.splice(fIndex, 1);
                    }
                });
                let unAddedLinks = linkDataArray.filter(s => diagramLinks.find(x => x.uid == s.uid) == null && s.id == -1);
                unAddedLinks.forEach(link => {
                    links.find(s => s.uid == link.uid).isAdded = false;
                    let fNodeIndex = fullLayout.nodes.find(s => s.key == link.from);
                    if (fNodeIndex != -1) {
                        let fIndex = fullLayout.nodes[fNodeIndex].relationships.findIndex(x => x.uid == link.uid);
                        if (fIndex != -1) {
                            fullLayout.nodes[fNodeIndex].relationships.splice(fIndex, 1);
                        }
                    }
                });
                modifyNodesAndLinks(diagramNodes, nodeDataArray, diagramLinks, linkDataArray);
            } else if (evt.Os == "Redo") {
                let nodeDataArray = Array.from(JSON.parse(JSON.stringify(nodes)));
                let diagramNodes = Array.from(JSON.parse(JSON.stringify(myDiagram.model.nodeDataArray)));
                let deletedNodes = nodeDataArray.filter(s => diagramNodes.find(x => x.id == s.id) == null);
                deletedNodes.forEach(node => {
                    let unChangedIndex = unchangedNodes.findIndex(u => u.id == node.id && u.type == LAYOUT_OBJECT_TYPES.BO);
                    let deleted = (unChangedIndex == -1);
                    nodes.find(s => s.id == node.id).visible = false;
                    nodes.find(s => s.id == node.id).isDeleted = deleted;
                    if (unChangedIndex != -1) {
                        let unChangedNode = JSON.parse(JSON.stringify(unchangedNodes[unChangedIndex]));
                        if (changedNodes.findIndex(s => s.id == unChangedNode.id && s.type == LAYOUT_OBJECT_TYPES.BO && s.state == LAYOUT_OBJECT_STATES.hidden) == -1) {
                            changedNodes.push(unChangedNode);
                            unchangedNodes.splice(unChangedIndex, 1);
                        }
                    }
                    let fullIndex = fullLayout.nodes.findIndex(s => s.id == node.id);
                    if (fullIndex != -1) {
                        fullLayout.nodes[fullIndex].visible = false;
                        fullLayout.nodes[fullIndex].isDeleted = deleted;
                    }
                });
                let linkDataArray = Array.from(JSON.parse(JSON.stringify(links)));
                let diagramLinks = Array.from(JSON.parse(JSON.stringify(myDiagram.model.linkDataArray)));
                let deletedLinks = linkDataArray.filter(s => diagramLinks.find(x => x.id == s.id) == null);
                deletedLinks.forEach(link => {
                    let unchangedLinkIndex = unchangedNodes.findIndex(u => u.id == link.id && u.type == LAYOUT_OBJECT_TYPES.REL);

                    if (unchangedLinkIndex != -1) {
                        let unChangedLink = JSON.parse(JSON.stringify(unchangedNodes[unchangedLinkIndex]));
                        changedNodes.push(unChangedLink);
                        unchangedNodes.splice(unchangedLinkIndex, 1);
                    }
                    let nodeIndex = fullLayout.nodes.findIndex(s => s.key == link.from);
                    if (nodeIndex != -1) {
                        let relIndex = fullLayout.nodes[nodeIndex].relationships.findIndex(s => s.id == link.id);
                        if (relIndex != -1) {
                            fullLayout.nodes[nodeIndex].relationships[relIndex].visible = false;
                        }
                    }
                    if (links.find(s => s.id == link.id) != null) {
                        links.find(s => s.id == link.id).visible = false;
                    }
                });

                let reAddedNodes = nodeDataArray.filter(s => diagramNodes.find(x => x.key == s.key && s.isAdded == false) != null);

                reAddedNodes.forEach(node => {
                    nodes.find(s => s.key == node.key).isAdded = true;
                });

                let reAddedLinks = linkDataArray.filter(s => diagramLinks.find(x => x.uid == s.uid && s.isAdded == false) != null);
                reAddedLinks.forEach(link => {
                    links.find(s => s.uid == link.uid).isAdded = true;
                });
                modifyNodesAndLinks(diagramNodes, nodeDataArray, diagramLinks, linkDataArray);
            } else if (evt.Os != "Initial Layout" && evt.Os != "Drag" && evt.Os != "Move" && evt.Os != "Undo" && evt.Os != "Redo" && evt.Os != null && evt.Os.length != 0) {

                if (myDiagram.selection != null && myDiagram.selection.fa != null) {
                    let data = myDiagram.selection.fa.value.jb;
                    if (myDiagram.selection.fa.value.va.name == "Auto") {
                        let data = myDiagram.selection.fa.value.jb;
                        let index = nodes.findIndex(s => s.key == data.key);
                        let changed = nodes.find(s => s.key == data.key && (s.description != data.description || s.name != data.name));
                        if (changed != null) {
                            myDiagram.selection.fa.value.jb.isChanged = true;
                        }
                        let node = jQuery.extend(true, {}, myDiagram.selection.fa.value.jb);
                        let dNode = myDiagram.findNodeForData(myDiagram.selection.fa.value.jb);

                        if (index != -1) {
                            nodes[index] = node;
                            nodes[index].location = {x: dNode.le.F, y: dNode.le.G};
                        } else {
                            node.isChanged = false;
                            node.location = {x: dNode.le.F, y: dNode.le.G};
                            nodes.push(node);
                        }
                    } else if (myDiagram.selection.fa.value.va.name == "Link") {
                        let data = myDiagram.selection.fa.value.jb;
                        let index = links.findIndex(s => s.uid == data.uid);
                        let changed = links.find(s => s.uid == data.uid && (s.reverse != data.reverse || s.forward != data.forward || s.relationship_name != data.relationship_name));
                        if (changed != null) {
                            myDiagram.selection.fa.value.jb.isChanged = true;
                            objectsChanged = true;
                        }

                        let link = jQuery.extend(true, {}, data);

                        if (index != -1) {
                            links[index] = link;
                        } else {
                            link.isChanged = false;
                            objectsChanged = true;
                            links.push(link);
                        }
                    }
                }
            }
        });

        // dragging a node invalidates the Diagram.layout, causing a layout during the drag
        myDiagram.toolManager.draggingTool.doMouseMove = function () {
            go.DraggingTool.prototype.doMouseMove.call(this);
        };

        let fieldTemplate =
            $(go.Panel, "TableRow",  // this Panel is a row in the containing Table
                new go.Binding("portId", "name"),  // this Panel is a "port"
                {
                    background: "transparent",  // so this port's background can be picked by the mouse
                },
                $(go.TextBlock,
                    {
                        margin: new go.Margin(0, 5), column: 1, font: "bold 13px sans-serif",
                        alignment: go.Spot.Left,
                        // and disallow drawing links from or to this text:
                        fromLinkable: false, toLinkable: false
                    },
                    new go.Binding("text", "name")),
            );

        // define each Node's appearance
        myDiagram.nodeTemplate =
            $(go.Node, "Auto",
                {
                    linkConnected: function (node, link, port) {
                        if (link.fromNode !== null) link.fromNode.invalidateConnectedLinks();
                        if (link.toNode !== null) link.toNode.invalidateConnectedLinks();
                    },
                    linkDisconnected: function (node, link, port) {
                        if (link.fromNode !== null) link.fromNode.invalidateConnectedLinks();
                        if (link.toNode !== null) link.toNode.invalidateConnectedLinks();
                    },
                    doubleClick: function (e, node) {
                        e.diagram.animationManager.prepareAutomaticAnimation("zoomToRect");
                        e.diagram.commandHandler.resetZoom();
                        e.diagram.centerRect(node.actualBounds);
                    },
                    resizable: true, resizeObjectName: "SHAPE",  // user can resize the Shape
                    rotatable: true, rotateObjectName: "SHAPE",  // rotate the Shape without rotating the label
                    avoidableMargin: new go.Margin(5, 5, 5, 5),
                    layoutConditions: go.Part.LayoutStandard & ~go.Part.LayoutNodeSized
                },
                new go.Binding("location", "location"),
                new go.Binding("visible", "visible"),
                new go.Binding("isTreeExpanded", "visible"),
                // define the node's outer shape, which will surround the TextBlock
                $(go.Shape, GOJS_SELECT_CHOICES.Circle,
                    {
                        name: "SHAPE",  // named so that the above properties can refer to this GraphObject
                        width: "auto",
                        height: "auto",
                        stroke: '#000',
                        minSize: new go.Size(50, 50),
                        maxSize: new go.Size(400, 400),
                        spot1: new go.Spot(0, 0, 5, 5),
                        spot2: new go.Spot(1, 1, -5, -5),
                        portId: "",
                        // use the following property if you want users to draw new links
                        // interactively by dragging from the Shape, and re-enable the LinkingTool
                        // in the initialization of the Diagram
                        //cursor: "pointer",
                        fromLinkable: true,
                        fromLinkableDuplicates: true, fromLinkableSelfNode: true,
                        toLinkable: true,
                        toLinkableDuplicates: true, toLinkableSelfNode: true
                    },
                    new go.Binding("fill", "color"),
                    new go.Binding("figure", "shape"),
                    new go.Binding("angle", "angle").makeTwoWay(),
                    new go.Binding("height", "height").makeTwoWay(),
                    new go.Binding("width", "width").makeTwoWay(),
                ),

                $(go.TextBlock,
                    {
                        font: "bold 10pt helvetica, bold arial, sans-serif",
                        textAlign: "center",
                        maxSize: new go.Size(100, NaN)
                    },
                    new go.Binding("text", "name"),
                    new go.Binding("key", "name"),
                    new go.Binding("stroke", "fontColor")),
                {
                    toolTip:                       // define a tooltip for each node
                        $(go.Adornment,      // that has several labels around it
                            $(go.Panel, "Vertical",
                                // this is the header for the whole node
                                $(go.Panel, "Auto",
                                    {stretch: go.GraphObject.Horizontal},  // as wide as the whole node
                                    $(go.Shape,
                                        {fill: "#1570A6", stroke: null}),
                                    $(go.TextBlock,
                                        {
                                            alignment: go.Spot.Center,
                                            margin: 3,
                                            stroke: "white",
                                            textAlign: "center",
                                            font: "bold 10pt sans-serif"
                                        },
                                        new go.Binding("text", "name"))),
                                // this Panel holds a Panel for each item object in the itemArray;
                                // each item Panel is defined by the itemTemplate to be a TableRow in this Table
                                $(go.Panel, "Table",
                                    {
                                        margin: -1,
                                        padding: 3,
                                        minSize: new go.Size(100, 10),
                                        defaultStretch: go.GraphObject.Horizontal,
                                        itemTemplate: fieldTemplate,
                                        background: "#d3d3d3"
                                    },
                                    $(go.Shape,
                                        {fill: "#d3d3d3", opacity: 0.5, stroke: null}),
                                    new go.Binding("itemArray", "attributes")
                                )  // end Table Panel of items
                            )  // end Vertical Panel
                        )  // end Adornment
                },
                $("HyperlinkText",
                    function (node) {
                        return node.jb.name;
                    },
                    {
                        margin: 1,
                        maxSize: new go.Size(100, 80),
                        textAlign: "center",
                        font: "bold 10pt helvetica, bold arial, sans-serif",
                        click: function (e, d) {
                            if (d.part.data.id !== -1) {
                                allowUpdate = false;
                                BusinessObjects.eventDispatcher(EVENTS.boView.setBusinessObject, {
                                    businessObject: businessObjectsWrapper.getBusinessObject(d.part.data.id)
                                });
                                setTimeout(() => {
                                    allowUpdate = true;
                                }, 1);
                            }
                        },
                    }, new go.Binding("text", "name"),
                    new go.Binding("stroke", "fontColor"))
            );

        // replace the default Link template in the linkTemplateMap
        myDiagram.linkTemplate =
            $(go.Link,
                {
                    reshapable: true,
                    resegmentable: true,
                    routing: go.Link.Normal,
                    corner: 10,
                    layoutConditions: go.Part.LayoutStandard & ~go.Part.LayoutNodeSized
                },
                new go.Binding("routing", "routing", go.Binding.parseEnum(go.Link, go.Link.Normal)).makeTwoWay(go.Binding.toString),
                new go.Binding("points", "points").makeTwoWay(function (e) {
                    return e.n;
                }),
                // the whole link panel
                $(go.Shape, {isPanelMain: true, stroke: "transparent", strokeWidth: 8}),
                $(go.Shape,  // the link shape
                    {isPanelMain: true, stroke: '#dee2e6', name: "LNKSHAPE", fill: '#dee2e6'},
                ),
                $(go.Shape,  // the arrowhead
                    {toArrow: "standard", stroke: '#dee2e6', name: "ARWSHAPE", fill: '#dee2e6'}
                ),
                $(go.Panel, "Auto",
                    {name: "LABEL"},
                    $(go.Shape,  // the label background, which becomes transparent around the edges
                        {
                            fill: $(go.Brush, "Radial", {
                                0: "rgb(55, 55, 55)",
                                0.3: "rgb(55, 55, 55)",
                                1: "rgba(55, 55, 55, 0)"
                            }),
                            stroke: null
                        }),
                    $(go.TextBlock,  // the label text
                        {
                            textAlign: "center",
                            font: "10pt helvetica, arial, sans-serif",
                            stroke: "#dee2e6",
                            margin: 4,
                            editable: true
                        },
                        new go.Binding("text", "forward")),
                    new go.Binding("visible", "labelVisible")
                )
            );

        myDiagram.click = function (e) {
            myDiagram.nodes.each(function (node) {
                node.highlight = "none";
            });
            myDiagram.links.each(function (link) {
                link.highlight = "none";
            });
            updateHighlights();
        };

        // How to do buttons
        myDiagram.nodeTemplate.selectionAdornmentTemplate =
            $(go.Adornment, "Spot",
                $(go.Panel, "Auto",
                    $(go.Shape, {stroke: "#1e90ff", strokeWidth: 2, fill: null}),
                    $(go.Placeholder)
                ),
                $(go.Panel, "Horizontal",
                    {alignment: go.Spot.TopRight, alignmentFocus: go.Spot.Bottom},
                    $("Button",
                        { // drawLink is defined below, to support interactively drawing new links
                            click: drawLink,  // click on Button and then click on target node
                            actionMove: drawLink  // drag from Button to the target node
                        },
                        $(go.Shape,
                            {geometryString: "M0 0 L8 0 8 12 14 12 M12 10 L14 12 12 14"})
                    ),
                    $("Button",
                        {
                            actionMove: dragNewNode,  // defined below, to support dragging from the button
                            _dragData: {
                                name: "",
                                color: "#d3d3d3",
                                description: "n/a",
                                key: shortid.generate(),
                                id: -1,
                                visible: true,
                                isDeleted: false,
                                shape: GOJS_SELECT_CHOICES.Circle,
                                angle: 0,
                                height: 100,
                                width: 100,
                                fontColor: "#000",
                                attributes: [],
                                systemRequired: false,
                                isAdded: true
                            },  // node data to copy
                            click: clickNewNode  // defined below, to support a click on the button
                        },
                        $(go.Shape,
                            {geometryString: "M0 0 L3 0 3 10 6 10 x F1 M6 6 L14 6 14 14 6 14z", fill: "gray"})
                    ),
                    $("Button",
                        {click: hideNode},
                        $(go.Shape,
                            {
                                geometryString: "M14.78 0.22c-0.293-0.293-0.768-0.293-1.061 0l-3.159 3.159c-0.812-0.246-1.671-0.378-2.561-0.378-3.489 0-6.514 2.032-8 5 0.643 1.283 1.573 2.391 2.703 3.236l-2.484 2.484c-0.293 0.293-0.293 0.768 0 1.061 0.146 0.146 0.338 0.22 0.53 0.22s0.384-0.073 0.53-0.22l13.5-13.5c0.293-0.293 0.293-0.768 0-1.061zM6.5 5c0.66 0 1.22 0.426 1.421 1.019l-1.902 1.902c-0.592-0.201-1.019-0.761-1.019-1.421 0-0.828 0.672-1.5 1.5-1.5zM1.721 8c0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 0.858 0.27 1.652 0.73 2.303l-0.952 0.952c-0.819-0.576-1.519-1.311-2.057-2.162z M12 6.906c0-0.424-0.066-0.833-0.189-1.217l-5.028 5.028c0.384 0.123 0.793 0.189 1.217 0.189 2.209 0 4-1.791 4-4z M12.969 4.531l-1.084 1.084c0.020 0.012 0.040 0.024 0.059 0.037 0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152-0.604 0-1.202-0.074-1.781-0.219l-1.201 1.201c0.933 0.335 1.937 0.518 2.982 0.518 3.489 0 6.514-2.032 8-5-0.703-1.405-1.752-2.6-3.031-3.469z",
                            })
                    ),
                    $("Button",
                        {click: deleteNode},
                        $(go.Shape,
                            {
                                geometryString: "M3 16h10l1-11h-12zM10 2v-2h-4v2h-5v3l1-1h12l1 1v-3h-5zM9 2h-2v-1h2v1z",
                                fill: "gray"
                            }),
                        new go.Binding("visible", "systemRequired", function (e) {
                            return !e;
                        })
                    ),
                )
            );

        function hideNode(e, button) {
            let diagramNode = myDiagram.findNodeForKey(myDiagram.selection.fa.value.jb.key);
            if (diagramNode != null) {
                let node = jQuery.extend(true, {}, diagramNode);
                node.jb.visible = false;
                node.jb.isChanged = false;
                node.jb.isDeleted = false;
                if (node.jb.id != -1) {
                    nodes.find(s => s.key == node.jb.key).visible = false;
                    nodes.find(s => s.key == node.jb.key).isDeleted = false;
                    nodes.find(s => s.key == node.jb.key).isChanged = false;
                    if (fullLayout != null) {
                        fullLayout.nodes.find(s => s.key == node.jb.key).visible = false;
                        fullLayout.nodes.find(s => s.key == node.jb.key).isDeleted = false;
                        fullLayout.nodes.find(s => s.key == node.jb.key).isChanged = false;
                    }
                } else {
                    let nd = nodes.findIndex(s => s.key == node.jb.key);
                    if (nd != -1) {
                        nodes.splice(nd, 1);
                    }
                    if (fullLayout != null) {
                        let fIndex = fullLayout.findIndex(s => s.key == node.jb.key);
                        if (fIndex != -1) {
                            fullLayout.nodes.splice(fIndex, 1);
                        }
                    }
                }

                if (node.jb.id != -1 && changedNodes.findIndex(s => s.id == node.jb.id && s.type == LAYOUT_OBJECT_TYPES.BO) == -1) {
                    changedNodes.push({
                        id: node.jb.id,
                        name: node.jb.name,
                        key: node.jb.key,
                        description: node.jb.description,
                        state: LAYOUT_OBJECT_STATES.hidden,
                        type: LAYOUT_OBJECT_TYPES.BO,
                        shape: node.jb.shape,
                        height: node.jb.height,
                        width: node.jb.width,
                        angle: node.jb.angle,
                        fontColor: node.jb.fontColor,
                        location: {x: node.le.F, y: node.le.G},
                        color: node.jb.color,
                        uniqueId: node.jb.name,
                        systemRequired: node.jb.systemRequired
                    });
                }

                let hiddenLinks = links.filter(s => s.from == node.jb.key || s.to == node.jb.key);
                hiddenLinks.forEach(hl => {
                    if (hl.id != -1 && changedNodes.findIndex(s => s.id == hl.id && s.type == LAYOUT_OBJECT_TYPES.REL) == -1) {
                        changedNodes.push({
                            id: hl.id,
                            relationship_name: hl.relationship_name,
                            state: LAYOUT_OBJECT_STATES.hidden,
                            type: LAYOUT_OBJECT_TYPES.REL,
                            from: hl.from,
                            to: hl.to,
                            forward: hl.forward,
                            reverse: hl.reverse,
                            routing: hl.routing,
                            uid: hl.uid,
                            labelVisible: showLabels,
                            points: hl.points,
                            uniqueId: hl.from + " " + hl.forward + " " + hl.to,
                            systemRequired: hl.systemRequired
                        });
                    }
                    hl.visible = false;
                });
                allowUpdate = false;
                myDiagram.remove(diagramNode);
                myDiagram.clearSelection();

                let updateNodes = new Promise((resolve, reject) => {
                    self.props.setHiddenAndModifiedBOCsForLayout(Array.from(changedNodes));
                });
                updateNodes.then(() => {
                    allowUpdate = true;
                });
            } else {
                let diagramLink = myDiagram.findLinkForData(myDiagram.selection.fa.value.jb);
                let link = jQuery.extend(true, {}, diagramLink);
                link.jb.visible = false;
                link.jb.isDeleted = false;
                link.jb.isChanged = false;
                if (link.jb.id != -1) {
                    links.find(s => s.id == link.jb.id).visible = false;
                    links.find(s => s.id == link.jb.id).isDeleted = false;
                    links.find(s => s.id == link.jb.id).isChanged = false;
                } else {
                    let filteredArray = links.filter(s => s.uid != link.jb.uid);
                    let lk = links.findIndex(s => s.uid == link.jb.uid);
                    if (lk != -1) {
                        links.splice(lk, 1);
                    }
                    links = [];
                    links = Array.from(filteredArray);
                }

                let fromNode = myDiagram.findNodeForKey(link.jb.from);
                let toNode = myDiagram.findNodeForKey(link.jb.to);
                if (link.jb.id != -1 && changedNodes.findIndex(s => s.id == link.jb.id && s.type == LAYOUT_OBJECT_TYPES.REL) == -1) {
                    changedNodes.push({
                        id: link.jb.id,
                        relationship_name: link.jb.relationship_name,
                        state: LAYOUT_OBJECT_STATES.hidden,
                        type: LAYOUT_OBJECT_TYPES.REL,
                        from: fromNode.jb.name,
                        to: toNode.jb.name,
                        forward: link.jb.forward,
                        reverse: link.jb.reverse,
                        routing: link.jb.routing,
                        uid: link.jb.uid,
                        labelVisible: showLabels,
                        points: link.jb.points,
                        uniqueId: fromNode.jb.name + " to " + toNode.jb.name + "; " + link.jb.name,
                        systemRequired: link.jb.systemRequired
                    });
                    allowUpdate = false;
                    myDiagram.remove(diagramLink);
                    myDiagram.clearSelection();
                    let updateNodes = new Promise((resolve, reject) => {
                        self.props.setHiddenAndModifiedBOCsForLayout(Array.from(changedNodes));
                    });
                    updateNodes.then(() => {
                        allowUpdate = true;
                    });
                }
            }
        }

        function deleteNode(e, button) {
            let diagramNode = myDiagram.findNodeForKey(myDiagram.selection.fa.value.jb.key);
            if (diagramNode != null) {
                let node = jQuery.extend(true, {}, diagramNode);
                node.jb.visible = false;
                node.jb.isChanged = false;
                node.jb.isDeleted = true;
                myDiagram.remove(diagramNode);
                myDiagram.clearSelection();
                objectsChanged = true;
                if (node.jb.id != -1) {
                    nodes.find(s => s.key == node.jb.key).visible = false;
                    nodes.find(s => s.key == node.jb.key).isDeleted = true;
                    nodes.find(s => s.key == node.jb.key).isChanged = false;

                    let deletedLinks = links.filter(s => s.from == node.jb.key || s.to == node.jb.key);
                    deletedLinks.forEach(dl => {
                        if (dl.id != -1) {
                            dl.isDeleted = true;
                            dl.visible = false;
                            dl.isChanged = false;
                        }
                    });
                } else {
                    let nd = nodes.findIndex(s => s.key == node.jb.key);
                    if (nd != -1) {
                        nodes.splice(nd, 1);
                    }
                }
            } else {
                let diagramLink = myDiagram.findLinkForData(myDiagram.selection.fa.value.jb);
                let link = jQuery.extend(true, {}, diagramLink);
                link.jb.visible = false;
                link.jb.isChanged = false;
                link.jb.isDeleted = true;
                myDiagram.remove(diagramLink);
                myDiagram.clearSelection();
                objectsChanged = true;
                if (link.jb.id != -1) {
                    links.find(s => s.uid == link.jb.uid).visible = false;
                    links.find(s => s.uid == link.jb.uid).isDeleted = true;
                    links.find(s => s.uid == link.jb.uid).isChanged = false;
                } else {
                    let lk = links.findIndex(s => s.id == link.jb.id);
                    if (lk != -1) {
                        links.splice(lk, 1);
                    }
                }
            }
        }

        function drawLink(e, button) {
            let node = button.part.adornedPart;
            let model = myDiagram.model;
            let tool = e.diagram.toolManager.linkingTool;
            tool.startObject = node.port;
            tool.archetypeLinkData = model.copyLinkData({
                relationship_name: "",
                forward: "",
                reverse: "",
                id: -1,
                routing: "Normal",
                uid: shortid.generate(),
                labelVisible: showLabels,
                visible: true,
                isAdded: true,
                systemRequired: false,
                points: []
            });
            e.diagram.currentTool = tool;
            tool.doActivate();
        }

        // used by both clickNewNode and dragNewNode to create a node and a link
        // from a given node to the new node
        function createNodeAndLink(data, fromNode) {
            let model = myDiagram.model;
            let nodeData = model.copyNodeData({
                key: shortid.generate(),
                id: -1,
                name: "",
                description: "n/a",
                color: "#d3d3d3",
                visible: true,
                shape: GOJS_SELECT_CHOICES.Circle,
                height: 100,
                width: 100,
                angle: 0,
                fontColor: "#000",
                attributes: [],
                isAdded: true,
                systemRequired: false
            });
            model.addNodeData(nodeData);
            let newNode = myDiagram.findNodeForData(nodeData);
            let linkData = model.copyLinkData({
                relationship_name: "",
                forward: "",
                reverse: "",
                id: -1,
                routing: "Normal",
                uid: shortid.generate(),
                labelVisible: showLabels,
                visible: true,
                isAdded: true,
                systemRequired: false,
                points: []
            });
            model.setFromKeyForLinkData(linkData, model.getKeyForNodeData(fromNode.jb));
            model.setToKeyForLinkData(linkData, model.getKeyForNodeData(newNode.jb));
            model.addLinkData(linkData);
            myDiagram.select(newNode);
            return newNode;
        }

        function createNode(data) {
            let model = myDiagram.model;
            let nodeData = model.copyNodeData({
                key: shortid.generate(),
                id: -1,
                name: "",
                description: "n/a",
                color: "#d3d3d3",
                visible: true,
                shape: GOJS_SELECT_CHOICES.Circle,
                height: 100,
                width: 100,
                angle: 0,
                location: new go.Point(data.x, data.y),
                fontColor: "#000",
                attributes: [],
                isAdded: true,
                systemRequired: false
            });
            model.addNodeData(nodeData);
            let newNode = myDiagram.findNodeForData(nodeData);
            newNode.location = new go.Point(data.x, data.y);
            myDiagram.select(newNode);
            return newNode;
        }

        // the Button.click event handler, called when the user clicks the "N" button
        function clickNewNode(e, button) {
            let data = button._dragData;
            if (!data) return;
            e.diagram.startTransaction("Create Node and Link");
            let fromNode = button.part.adornedPart;
            let newNode = createNodeAndLink(button._dragData, fromNode);
            newNode.location = new go.Point(fromNode.location.x - 200, fromNode.location.y);
            e.diagram.commitTransaction("Create Node and Link");
        }

        // the Button.actionMove event handler, called when the user drags within the "N" button
        function dragNewNode(e, button) {
            let tool = e.diagram.toolManager.draggingTool;
            if (tool.isBeyondDragSize()) {
                let data = button._dragData;
                if (!data) return;
                e.diagram.startTransaction("button drag");  // see doDeactivate, below
                let newNode = createNodeAndLink(data, button.part.adornedPart);
                newNode.location = e.diagram.lastInput.documentPoint;
                // don't commitTransaction here, but in tool.doDeactivate, after drag operation finished
                // set tool.currentPart to a selected movable Part and then activate the DraggingTool
                tool.currentPart = newNode;
                e.diagram.currentTool = tool;
                tool.doActivate();
            }
        }

        function setHighligthed(node) {
            node.findLinksOutOf().each(function (l) {
                l.highlight = "out";
            });
            // for each Node destination for the Node, set Node.highlight
            node.findNodesOutOf().each(function (n) {
                n.highlight = "out";
            });

            node.findLinksInto().each(function (l) {
                l.highlight = "in";
            });

            node.findNodesInto().each(function (n) {
                if (n.highlight == "out") {
                    n.highlight = "inout";
                } else {
                    n.highlight = "in";
                }
            });
        }

        function selectionChanged() {
            myDiagram.nodes.each(function (node) {
                node.highlight = "none";
            });
            myDiagram.links.each(function (link) {
                link.highlight = "none";
            });
            if (myDiagram.selection.fa != null) {


                let node = myDiagram.selection.first();

                if (node != null && myDiagram.selection.fa.value.va.name == "Auto") {
                    jQuery("#nodeInspector").prop("hidden", false);
                    jQuery("#delete_relationship_btn").css("display", "none");
                    // for each Link coming out of the Node, set Link.highlight
                    setHighligthed(node);
                } else if (node != null && myDiagram.selection.fa.value.va.name == "Link" && !myDiagram.selection.fa.value.jb.systemRequired) {
                    jQuery("#linkInspector").prop("hidden", false);
                    jQuery("#delete_relationship_btn").css("display", "block");
                } else if (node != null && myDiagram.selection.fa.value.va.name == "Link" && myDiagram.selection.fa.value.jb.systemRequired) {
                    jQuery("#linkInspector").prop("hidden", false);
                    jQuery("#delete_relationship_btn").css("display", "none");
                }
                updateHighlights();
            } else {
                jQuery("#nodeInspector").prop("hidden", true);
                jQuery("#linkInspector").prop("hidden", true);
                jQuery("#delete_relationship_btn").css("display", "none");
            }
        }

        function highlight(shp, obj2, hl) {
            let color = '#dee2e6';
            let width = 1;
            let scale = 1;
            if (hl === "none") {
                color = '#dee2e6';
                width = 1;
            } else if (hl === "out") {
                color = "#b4240f";
                width = 4;
                scale = 2;
            } else if (hl === "in") {
                color = "#0710cf";
                width = 4;
                scale = 2;
            } else if (hl === "inout") {
                color = "#c240c9";
                width = 6;
                scale = 2;
            }
            shp.stroke = color;
            shp.strokeWidth = width;
            if (obj2 !== null) {
                obj2.stroke = color;
                obj2.fill = color;
                obj2.scale = scale;
            }
        }

        function updateHighlights() {
            //nodes
            myDiagram.nodes.each(function (node) {
                let shp = node.findObject("SHAPE");
                let hl = node.highlight;
                if (shp != null) {
                    highlight(shp, null, hl);
                }
            });
            // links
            myDiagram.links.each(function (link) {
                let hl = link.highlight;
                let shp = link.findObject("LNKSHAPE");
                let arw = link.findObject("ARWSHAPE");
                if (shp != null) {
                    highlight(shp, arw, hl);
                }
            });
        }

        // using dragNewNode also requires modifying the standard DraggingTool so that it
        // only calls commitTransaction when dragNewNode started a "button drag" transaction;
        // do this by overriding DraggingTool.doDeactivate:
        let tool = myDiagram.toolManager.draggingTool;
        tool.doDeactivate = function () {
            // commit "button drag" transaction, if it is ongoing; see dragNewNode, above
            if (tool.diagram.undoManager.nestedTransactionNames.elt(0) === "button drag") {
                tool.diagram.commitTransaction();
            }
            go.DraggingTool.prototype.doDeactivate.call(tool);  // call the base method
        };

        // create the model for the concept map
        let nodeDataArray = [];
        let linkDataArray = [];
        const data = businessObjectsWrapper.getBusinessObjects(DataTypesEnum.ARRAY);
        if (currentLayout != null) {
            if (autoCurrentLayout && nodes.length > 0) {
                nodes.forEach(node => {
                    if (node.visible == true && node.isDeleted != true) {
                        nodeDataArray.push({
                            key: node.key,
                            id: node.id,
                            name: node.name,
                            color: node.color || go.Brush.randomColor(),
                            description: node.description,
                            visible: true,
                            shape: node.shape != null ? node.shape : GOJS_SELECT_CHOICES.Circle,
                            width: node.width != null ? node.width : NaN,
                            height: node.height != null ? node.height : NaN,
                            angle: node.angle != null ? node.angle : 0,
                            fontColor: node.fontColor != null ? node.fontColor : '#000',
                            systemRequired: node.systemRequired != null ? node.systemRequired : false,
                            attributes: data.find(s => s.id == node.id) != null ? Array.from(data.find(s => s.id == node.id).attributes.values()).sort((a, b) => a.name.localeCompare(b.name)) : []
                        });
                    }

                    if (node.visible == false && node.isDeleted != true) {
                        let boc = {
                            id: node.id,
                            name: node.name,
                            key: node.key,
                            description: node.description,
                            state: LAYOUT_OBJECT_STATES.hidden,
                            type: LAYOUT_OBJECT_TYPES.BO,
                            shape: node.shape,
                            height: node.height,
                            width: node.width,
                            angle: node.angle,
                            fontColor: node.fontColor,
                            location: node.location,
                            color: node.color,
                            uniqueId: node.name,
                            systemRequired: node.systemRequired
                        };
                        if (changedNodes.findIndex(b => b.id == boc.id && b.type == LAYOUT_OBJECT_TYPES.BO) == -1) {
                            changedNodes.push(boc);
                        }
                    }
                });

                if (links.length > 0) {
                    links.forEach(l => {
                        linkDataArray.push({
                            id: l.id,
                            relationship_name: l.relationship_name,
                            forward: l.forward,
                            reverse: l.reverse,
                            from: l.from,
                            to: l.to,
                            visible: l.visible,
                            routing: l.routing,
                            labelVisible: showLabels,
                            uid: l.uid,
                            systemRequired: l.systemRequired,
                            points: l.points
                        });
                        if (l.visible == false && l.isDeleted != true) {
                            if (changedNodes.findIndex(b => b.id == l.id && b.type == LAYOUT_OBJECT_TYPES.REL) == -1) {
                                changedNodes.push(l);
                            }
                        }
                    });
                }
            } else if (autoCurrentLayout) {
                currentLayout.nodes.forEach(node => {
                    let dataNode = data.find(s => s.id == node.id);
                    if (dataNode != null && node.visible) {
                        nodeDataArray.push({
                            key: node.key,
                            id: node.id,
                            name: dataNode.name,
                            color: node.color || go.Brush.randomColor(),
                            description: dataNode.description,
                            visible: true,
                            shape: node.shape != null ? node.shape : GOJS_SELECT_CHOICES.Circle,
                            width: node.width != null ? node.width : NaN,
                            height: node.height != null ? node.height : NaN,
                            angle: node.angle != null ? node.angle : 0,
                            fontColor: node.fontColor != null ? node.fontColor : '#000',
                            systemRequired: node.systemRequired != null ? node.systemRequired : false,
                            attributes: Array.from(dataNode.attributes.values()).sort((a, b) => a.name.localeCompare(b.name))
                        });

                        if (node.relationships != null && node.relationships.length > 0) {
                            node.relationships.forEach(relationship => {
                                let uid = relationship.uid != null ? relationship.uid : shortid.generate();
                                if (linkDataArray.find(s => s.id == relationship.id) == null) {
                                    if (relationship.visible) {
                                        linkDataArray.push({
                                            id: relationship.id,
                                            from: relationship.from,
                                            to: relationship.to,
                                            relationship_name: relationship.relationship_name,
                                            forward: relationship.forward,
                                            reverse: relationship.reverse,
                                            visible: true,
                                            routing: relationship.routing != null ? relationship.routing : "Normal",
                                            labelVisible: showLabels,
                                            uid: uid,
                                            systemRequired: relationship.systemRequired,
                                            points: relationship.points
                                        });
                                    }
                                    if (relationship.visible == false) {
                                        let changedLink = {
                                            id: relationship.id,
                                            relationship_name: relationship.relationship_name,
                                            from: relationship.from,
                                            to: relationship.to,
                                            forward: relationship.forward,
                                            reverse: relationship.reverse,
                                            state: LAYOUT_OBJECT_STATES.hidden,
                                            type: LAYOUT_OBJECT_TYPES.REL,
                                            routing: relationship.routing != null ? relationship.routing : "Normal",
                                            uniqueId: relationship.from + " to " + relationship.to + "; " + relationship.relationship_name,
                                            labelVisible: showLabels,
                                            uid: uid,
                                            systemRequired: relationship.systemRequired,
                                            points: relationship.points
                                        };
                                        if (changedNodes.findIndex(b => b.id == changedLink.id && b.type == LAYOUT_OBJECT_TYPES.REL) == -1) {
                                            changedNodes.push(changedLink);
                                        }
                                    }
                                }
                            })
                        }
                    } else if (dataNode != null && node.visible == false && node.isDeleted != true) {
                        let boc = {
                            id: node.id,
                            name: dataNode.name,
                            key: dataNode.name,
                            description: dataNode.description,
                            state: LAYOUT_OBJECT_STATES.hidden,
                            type: LAYOUT_OBJECT_TYPES.BO,
                            shape: node.shape,
                            height: node.height,
                            width: node.width,
                            angle: node.angle,
                            fontColor: node.fontColor,
                            location: node.location,
                            color: node.color,
                            uniqueId: dataNode.name,
                            systemRequired: dataNode.systemRequired
                        };
                        if (changedNodes.findIndex(b => b.id == boc.id && b.type == LAYOUT_OBJECT_TYPES.BO) == -1) {
                            changedNodes.push(boc);
                        }
                    }
                });
            } else if (!autoCurrentLayout) {
                if (nodes.length > 0) {
                    nodes.forEach(node => {
                        let dataNode = data.find(s => s.id == node.id);
                        if (dataNode != null && node.visible) {
                            nodeDataArray.push({
                                key: node.key,
                                id: node.id,
                                name: dataNode.name,
                                color: node.color || go.Brush.randomColor(),
                                description: dataNode.description,
                                visible: true,
                                shape: node.shape != null ? node.shape : GOJS_SELECT_CHOICES.Circle,
                                location: new go.Point(node.location.x, node.location.y),
                                width: node.width != null ? node.width : NaN,
                                height: node.height != null ? node.height : NaN,
                                angle: node.angle != null ? node.angle : 0,
                                fontColor: node.fontColor != null ? node.fontColor : '#000',
                                systemRequired: dataNode.systemRequired,
                                attributes: data.find(s => s.id == node.id) != null ? Array.from(data.find(s => s.id == node.id).attributes.values()).sort((a, b) => a.name.localeCompare(b.name)) : []
                            });
                        } else if (dataNode != null && node.visible == false && node.isDeleted != true) {
                            let boc = {
                                id: node.id,
                                name: dataNode.name,
                                key: dataNode.name,
                                description: dataNode.description,
                                state: LAYOUT_OBJECT_STATES.hidden,
                                type: LAYOUT_OBJECT_TYPES.BO,
                                shape: node.shape,
                                height: node.height,
                                width: node.width,
                                angle: node.angle,
                                fontColor: node.fontColor,
                                location: node.location,
                                color: node.color,
                                uniqueId: dataNode.name,
                                systemRequired: dataNode.systemRequired
                            };
                            if (changedNodes.findIndex(b => b.id == boc.id && b.type == LAYOUT_OBJECT_TYPES.BO) == -1) {
                                changedNodes.push(boc);
                            }
                        }
                    });
                    if (links.length > 0) {
                        links.forEach(l => {
                            linkDataArray.push({
                                id: l.id,
                                relationship_name: l.relationship_name,
                                forward: l.forward,
                                reverse: l.reverse,
                                from: l.from,
                                to: l.to,
                                visible: l.visible,
                                routing: l.routing,
                                labelVisible: showLabels,
                                uid: l.uid,
                                systemRequired: l.systemRequired,
                                points: l.points
                            });
                        });
                    }
                } else {
                    currentLayout.nodes.forEach((node, index, array) => {
                        let dataNode = data.find(s => s.id == node.id);
                        if (dataNode != null) {
                            if (node.location != null && node.location.x != null && node.visible) {
                                nodeDataArray.push({
                                    key: node.key,
                                    id: node.id,
                                    name: dataNode.name,
                                    color: node.color || go.Brush.randomColor(),
                                    location: new go.Point(node.location.x, node.location.y),
                                    description: dataNode.description,
                                    visible: node.visible != null ? node.visible : true,
                                    shape: node.shape != null ? node.shape : GOJS_SELECT_CHOICES.Circle,
                                    width: node.width != null ? node.width : NaN,
                                    height: node.height != null ? node.height : NaN,
                                    angle: node.angle != null ? node.angle : 0,
                                    fontColor: node.fontColor != null ? node.fontColor : '#000',
                                    systemRequired: dataNode.systemRequired,
                                    attributes: data.find(s => s.id == node.id) != null ? Array.from(data.find(s => s.id == node.id).attributes.values()).sort((a, b) => a.name.localeCompare(b.name)) : []
                                });
                            } else if (node.visible) {
                                nodeDataArray.push({
                                    key: node.key,
                                    id: node.id,
                                    name: dataNode.name,
                                    color: node.color || go.Brush.randomColor(),
                                    description: dataNode.description,
                                    visible: node.visible != null ? node.visible : true,
                                    shape: node.shape != null ? node.shape : GOJS_SELECT_CHOICES.Circle,
                                    width: node.width != null ? node.width : NaN,
                                    height: node.height != null ? node.height : NaN,
                                    angle: node.angle != null ? node.angle : 0,
                                    fontColor: node.fontColor != null ? node.fontColor : '#000',
                                    systemRequired: dataNode.systemRequired,
                                    attributes: data.find(s => s.id == node.id) != null ? Array.from(data.find(s => s.id == node.id).attributes.values()).sort((a, b) => a.name.localeCompare(b.name)) : []
                                });
                            }

                            if (node.visible == false && node.isDeleted != true) {
                                let boc = {
                                    id: node.id,
                                    name: dataNode.name,
                                    description: dataNode.description,
                                    state: LAYOUT_OBJECT_STATES.hidden,
                                    type: LAYOUT_OBJECT_TYPES.BO,
                                    location: node.location,
                                    color: node.color != null ? node.color : go.Brush.randomColor(),
                                    fontColor: node.fontColor != null ? node.fontColor : "#000",
                                    shape: node.shape != null ? node.shape : GOJS_SELECT_CHOICES.Circle,
                                    width: node.width != null ? node.width : NaN,
                                    height: node.height != null ? node.height : NaN,
                                    angle: node.angle != null ? node.angle : 0,
                                    systemRequired: dataNode.systemRequired,
                                    uniqueId: dataNode.name
                                };
                                if (changedNodes.findIndex(b => b.id == boc.id && b.type == LAYOUT_OBJECT_TYPES.BO) == -1) {
                                    changedNodes.push(boc);
                                }
                            }

                            if (node.relationships != null && node.relationships.length > 0) {
                                node.relationships.forEach(relationship => {
                                    let uid = relationship.uid != null ? relationship.uid : shortid.generate();
                                    let rel = Array.from(dataNode.relationships.values()).find(s => s.id == relationship.id);

                                    if (linkDataArray.find(s => s.id == relationship.id) == null && rel != null) {
                                        if (relationship.visible) {
                                            linkDataArray.push({
                                                id: relationship.id,
                                                from: relationship.from,
                                                to: relationship.to,
                                                relationship_name: relationship.relationship_name,
                                                forward: relationship.forward,
                                                reverse: relationship.reverse,
                                                visible: true,
                                                routing: relationship.routing != null ? relationship.routing : "Normal",
                                                labelVisible: showLabels,
                                                uid: uid,
                                                systemRequired: relationship.systemRequired != null ? relationship.systemRequired : false,
                                                points: relationship.points
                                            });
                                        }
                                        if (relationship.visible == false && relationship.isDeleted != true) {
                                            let changedLink = {
                                                id: relationship.id,
                                                relationship_name: relationship.relationship_name,
                                                from: relationship.from,
                                                to: relationship.to,
                                                forward: relationship.forward,
                                                reverse: relationship.reverse,
                                                state: LAYOUT_OBJECT_STATES.hidden,
                                                type: LAYOUT_OBJECT_TYPES.REL,
                                                routing: relationship.routing != null ? relationship.routing : "Normal",
                                                uniqueId: relationship.from + " to " + relationship.to + "; " + relationship.relationship_name,
                                                labelVisible: showLabels,
                                                uid: uid,
                                                systemRequired: relationship.systemRequired != null ? relationship.systemRequired : false,
                                                points: relationship.points
                                            };
                                            if (changedNodes.findIndex(b => b.id == changedLink.id && b.type == LAYOUT_OBJECT_TYPES.REL) == -1) {
                                                changedNodes.push(changedLink);
                                            }
                                        }
                                    }
                                })
                            }
                        } else {
                            array.splice(index, 1);
                        }
                    });
                }
            }
        } else if (autoCurrentLayout) {
            if (nodes.length > 0) {
                nodes.forEach(node => {
                    if (node.visible) {
                        nodeDataArray.push({
                            key: node.key,
                            id: node.id,
                            name: node.name,
                            color: node.color || go.Brush.randomColor(),
                            description: node.description,
                            visible: true,
                            shape: node.shape != null ? node.shape : GOJS_SELECT_CHOICES.Circle,
                            width: node.width != null ? node.width : NaN,
                            height: node.height != null ? node.height : NaN,
                            angle: node.angle != null ? node.angle : 0,
                            fontColor: node.fontColor != null ? node.fontColor : '#000',
                            systemRequired: node.systemRequired != null ? node.systemRequired : false,
                            attributes: data.find(s => s.id == node.id) != null ? Array.from(data.find(s => s.id == node.id).attributes.values()).sort((a, b) => a.name.localeCompare(b.name)) : []
                        });
                    }
                    if (node.visible == false && node.isDeleted != true) {
                        let boc = {
                            id: node.id,
                            name: node.name,
                            key: node.name,
                            description: node.description,
                            state: LAYOUT_OBJECT_STATES.hidden,
                            type: LAYOUT_OBJECT_TYPES.BO,
                            shape: node.shape,
                            height: node.height,
                            width: node.width,
                            angle: node.angle,
                            fontColor: node.fontColor,
                            location: node.location,
                            color: node.color,
                            uniqueId: node.name,
                            systemRequired: node.systemRequired != null ? node.systemRequired : false,
                        };
                        if (changedNodes.findIndex(b => b.id == boc.id && b.type == LAYOUT_OBJECT_TYPES.BO) == -1) {
                            changedNodes.push(boc);
                        }
                    }
                });
                if (links.length > 0) {
                    links.forEach(l => {
                        linkDataArray.push({
                            id: l.id,
                            relationship_name: l.relationship_name,
                            forward: l.forward,
                            reverse: l.reverse,
                            from: l.from,
                            to: l.to,
                            visible: l.visible,
                            routing: l.routing,
                            labelVisible: showLabels,
                            uid: l.uid,
                            systemRequired: l.systemRequired,
                            points: l.points
                        });
                        if (l.visible == false && l.isDeleted != true) {
                            if (changedNodes.findIndex(b => b.id == l.id && b.type == LAYOUT_OBJECT_TYPES.REL) == -1) {
                                changedNodes.push(l);
                            }
                        }
                    });
                }
            }
        } else if (fullLayout != null) {
            if (nodes.length > 0) {
                nodes.forEach(node => {
                    if (node.visible) {
                        nodeDataArray.push({
                            key: node.key,
                            id: node.id,
                            name: node.name,
                            color: node.color || go.Brush.randomColor(),
                            description: node.description,
                            visible: true,
                            shape: node.shape != null ? node.shape : "Circle",
                            width: node.width != null ? node.width : NaN,
                            height: node.height != null ? node.height : NaN,
                            angle: node.angle != null ? node.angle : 0,
                            fontColor: node.fontColor != null ? node.fontColor : "black",
                            systemRequired: node.systemRequired != null ? node.systemRequired : false,
                            attributes: data.find(s => s.id == node.id) != null ? Array.from(data.find(s => s.id == node.id).attributes.values()).sort((a, b) => a.name.localeCompare(b.name)) : []
                        });
                    }
                    if (node.visible == false && node.isDeleted != true) {
                        let boc = {
                            id: node.id,
                            name: node.name,
                            key: node.name,
                            description: node.description,
                            state: LAYOUT_OBJECT_STATES.hidden,
                            type: LAYOUT_OBJECT_TYPES.BO,
                            shape: node.shape,
                            height: node.height,
                            width: node.width,
                            angle: node.angle,
                            fontColor: node.fontColor,
                            location: node.location,
                            color: node.color,
                            uniqueId: node.name,
                            systemRequired: node.systemRequired != null ? node.systemRequired : false,
                        };
                        if (changedNodes.findIndex(b => b.id == boc.id && b.type == LAYOUT_OBJECT_TYPES.BO) == -1) {
                            changedNodes.push(boc);
                        }
                    }
                });
                if (links.length > 0) {
                    links.forEach(l => {
                        linkDataArray.push({
                            id: l.id,
                            relationship_name: l.relationship_name,
                            forward: l.forward,
                            reverse: l.reverse,
                            from: l.from,
                            to: l.to,
                            visible: l.visible,
                            routing: l.routing,
                            labelVisible: l.labelVisible,
                            uid: l.uid,
                            systemRequired: l.systemRequired,
                            points: l.points
                        });
                        if (l.visible == false && l.isDeleted != true) {
                            if (changedNodes.findIndex(b => b.id == l.id && b.type == LAYOUT_OBJECT_TYPES.REL) == -1) {
                                changedNodes.push(l);
                            }
                        }
                    });
                }
            } else {
                fullLayout.nodes.forEach(node => {
                    nodeDataArray.push({
                        key: node.key,
                        id: node.id,
                        name: node.name,
                        color: node.color,
                        location: node.location,
                        description: node.description,
                        visible: node.visible,
                        shape: node.shape,
                        height: node.height,
                        width: node.width,
                        angle: node.angle,
                        fontColor: node.fontColor,
                        attributes: node.attributes,
                        systemRequired: node.systemRequired
                    });
                    node.relationships.forEach(relationship => {
                        linkDataArray.push({
                            id: relationship.id,
                            from: relationship.from,
                            to: relationship.to,
                            relationship_name: relationship.relationship_name,
                            forward: relationship.forward,
                            reverse: relationship.reverse,
                            visible: relationship.visible,
                            routing: relationship.routing,
                            labelVisible: showLabels,
                            uid: shortid.generate(),
                            systemRequired: relationship.systemRequired
                        })
                    })
                });
            }
        } else if (data.length > 0) {
            data.forEach(value => {
                if (value.location != null) {
                    nodeDataArray.push({
                        key: value.name,
                        id: value.id,
                        name: value.name,
                        color: value.color || go.Brush.randomColor(),
                        location: value.location,
                        description: value.description,
                        visible: true,
                        shape: GOJS_SELECT_CHOICES.Circle,
                        height: NaN,
                        width: NaN,
                        angle: 0,
                        fontColor: value.fontColor != null ? value.fontColor : '#000',
                        attributes: Array.from(value.attributes.values()).sort((a, b) => a.name.localeCompare(b.name)),
                        systemRequired: value.systemRequired
                    });
                } else {
                    nodeDataArray.push({
                        key: value.name,
                        id: value.id,
                        name: value.name,
                        color: go.Brush.randomColor(),
                        description: value.description,
                        visible: true,
                        shape: GOJS_SELECT_CHOICES.Circle,
                        height: NaN,
                        width: NaN,
                        angle: 0,
                        fontColor: value.fontColor != null ? value.fontColor : '#000',
                        attributes: Array.from(value.attributes.values()).sort((a, b) => a.name.localeCompare(b.name)),
                        systemRequired: value.systemRequired
                    });
                }
            });

            data.forEach(value => {
                value.relationships.forEach(relationship => {
                    let fromNode = nodeDataArray.find(s => s.id == relationship.fromBoClass.id && s.visible);
                    let toNode = nodeDataArray.find(s => s.id == relationship.toBoClass.id && s.visible);
                    if (fromNode != null && toNode != null && linkDataArray.find(s => s.id == relationship.id) == null) {
                        linkDataArray.push({
                            id: relationship.id,
                            from: fromNode.key,
                            to: toNode.key,
                            relationship_name: relationship.name,
                            forward: relationship.inward,
                            reverse: relationship.outward,
                            visible: true,
                            routing: "Normal",
                            labelVisible: showLabels,
                            uid: shortid.generate(),
                            systemRequired: relationship.systemRequired,
                            points: []
                        });
                    }
                });
            });
        }

        if (myDiagram.model == null) {
            myDiagram.model = new go.GraphLinksModel(nodeDataArray, linkDataArray);
            myDiagram.model.undoManager.isEnabled = true;
        } else {
            myDiagram.model.nodeDataArray = nodeDataArray;
            myDiagram.model.linkDataArray = linkDataArray;
            myDiagram.model.undoManager.isEnabled = true;
        }
        if (nodes.length == 0 && links.length == 0) {
            nodes = Array.from(JSON.parse(JSON.stringify(myDiagram.model.nodeDataArray)));
            links = Array.from(JSON.parse(JSON.stringify(myDiagram.model.linkDataArray)));
        }

        if (currentLayout == null) {
            fullLayout = null;
            let layoutNodes = [];
            myDiagram.nodes.each(function (n) {
                if (n.jb.id != -1) {
                    let node = {
                        key: n.jb.key,
                        id: n.jb.id,
                        name: n.jb.name,
                        description: n.jb.description,
                        color: n.jb.color,
                        location: {x: n.le.F, y: n.le.G},
                        visible: n.jb.visible,
                        shape: n.jb.shape,
                        height: n.jb.height,
                        width: n.jb.width,
                        angle: n.jb.angle,
                        fontColor: n.jb.fontColor,
                        attributes: n.jb.attributes,
                        relationships: [],
                        systemRequired: n.jb.systemRequired
                    };
                    layoutNodes.push(node);
                }
            });
            let myModelNodes = Array.from(JSON.parse(JSON.stringify(nodes)));
            let myModelLinks = Array.from(JSON.parse(JSON.stringify(links)));
            myModelNodes.forEach(m => {

                if (m.visible == false && (m.isDeleted == false || m.isDeleted == null) && m.id != -1) {
                    let node = {
                        key: m.key,
                        id: m.id,
                        name: m.name,
                        description: m.description,
                        color: m.color,
                        location: m.location,
                        visible: false,
                        shape: m.shape,
                        height: m.height,
                        width: m.width,
                        angle: m.angle,
                        fontColor: m.fontColor,
                        attributes: m.attributes,
                        relationships: [],
                        systemRequired: m.systemRequired
                    };
                    if (layoutNodes.findIndex(s => s.id == m.id) == -1) {
                        layoutNodes.push(node);
                    }
                }
            });
            myModelLinks.forEach(link => {
                if (link.id != -1) {
                    let lNode = layoutNodes.find(s => s.key == link.from);
                    let toNode = layoutNodes.find(s => s.key == link.to);
                    if (lNode != null && toNode != null) {
                        let visible = lNode.visible && toNode.visible;
                        let relation = {
                            id: link.id,
                            relationship_name: link.relationship_name,
                            from: link.from,
                            to: link.to,
                            reverse: link.reverse,
                            forward: link.forward,
                            routing: link.routing,
                            visible: !visible ? false : link.visible,
                            labelVisible: showLabels,
                            systemRequired: link.systemRequired,
                            points: link.points
                        };
                        if (lNode != null && lNode != undefined) {
                            lNode.relationships.push(relation);
                        }
                    }
                }
            });
            fullLayout = {
                id: -1,
                name: "Full diagram (auto)",
                nodes: layoutNodes
            };
        }

        if (currentBusinessObject != undefined && currentBusinessObject != null && currentBusinessObject.id != null && currentBusinessObject.id != -1) {
            let node = null;
            if (nodes.find(n => n.name == currentBusinessObject.name) != null) {
                node = myDiagram.findNodeForKey(nodes.find(n => n.name == currentBusinessObject.name).key);
            }
            // remove any previous highlighting
            myDiagram.nodes.each(function (node) {
                node.highlight = "none";
            });
            myDiagram.links.each(function (link) {
                link.highlight = "none";
            });
            if (node != null) {
                // for each Link coming out of the Node, set Link.highlight
                setHighligthed(node);
                updateHighlights();
                myDiagram.select(node);
            }
        }

        function initialLayoutCompleted(e) {
            if (currentLayout != null) {
                data.forEach(d => {
                    let myModelNodeData = Array.from(JSON.parse(JSON.stringify(currentLayout.nodes)));
                    if (nodes.length > 0) {
                        myModelNodeData = Array.from(JSON.parse(JSON.stringify(nodes)));
                    }
                    let n = myModelNodeData.findIndex(s => s.id == d.id);

                    if (n == -1 && changedNodes.findIndex(s => s.id == d.id && s.type == LAYOUT_OBJECT_TYPES.BO) == -1) {
                        changedNodes.push({
                            id: d.id,
                            name: d.name,
                            description: d.description,
                            state: LAYOUT_OBJECT_STATES.created,
                            type: LAYOUT_OBJECT_TYPES.BO,
                            uniqueId: d.name,
                            systemRequired: d.systemRequired
                        });
                    }
                    let rels = Array.from(d.relationships.values());

                    rels.forEach(r => {
                        let l = -1;
                        if (links.length == 0) {
                            l = myModelNodeData.findIndex(s => s.relationships != null ? s.relationships.find(d => d.id == r.id) != null : false);
                        } else {
                            let myModelLinkData = Array.from(JSON.parse(JSON.stringify(links)));
                            l = myModelLinkData.findIndex(d => d.id == r.id);
                        }

                        if (l == -1 && changedNodes.findIndex(s => s.id == r.id && s.type == LAYOUT_OBJECT_TYPES.REL) == -1) {
                            changedNodes.push({
                                id: r.id,
                                relationship_name: r.name,
                                from: r.fromBoClass.name,
                                to: r.toBoClass.name,
                                forward: r.inward,
                                reverse: r.outward,
                                state: LAYOUT_OBJECT_STATES.created,
                                type: LAYOUT_OBJECT_TYPES.REL,
                                uniqueId: r.fromBoClass.name + " to " + r.toBoClass.name + "; " + r.id.toString() + r.name,
                                systemRequired: r.systemRequired,
                                points: []
                            })
                        }
                    })
                });
            }
            if (!compareNodes(changedNodes, hiddenAndModifiedBOCsForLayout) && currentLayout != null && !systemObjectsToggle) {
                allowUpdate = false;
                self.props.setHiddenAndModifiedBOCsForLayout(Array.from(changedNodes));
            }
            autoCurrentLayout = false;
            systemObjectsToggle = false;
        }

        function compareNodes(changed, hidden) {
            if (changed.length != hidden.length) {
                return false;
            }
            if (changed.length != 0 && hidden.length != 0) {
                if (changed.findIndex(s => hidden.some(d => d.id == s.id)) == -1) {
                    return false;
                }
                if (hidden.findIndex(s => changed.some(d => d.id == s.id)) == -1) {
                    return false;
                }
            }
            return true;
        }

        let nodeInspector = new Inspector("nodeInspector", myDiagram, {
            properties: {
                "name": {show: Inspector.showIfNode && Inspector.showIfPresent},
                "description": {show: Inspector.showIfNode && Inspector.showIfPresent, type: "textarea"},
                "systemRequired": {
                    show: Inspector.showIfNode, type: "select",
                    choices: function (node, propName) {
                        return ["true", "false"];
                    }
                },
                "color": {type: 'color', show: Inspector.showIfNode && Inspector.showIfPresent},

                "fontColor": {type: 'color', show: Inspector.showIfNode && Inspector.showIfPresent},
                "shape": {
                    show: Inspector.showIfNode, type: "select",
                    choices: function (node, propName) {
                        if (Array.isArray(node.jb.choices)) {
                            return node.jb.choices;
                        }
                        return ["Beaker", "Boat Shipment", "Building", "Card", "Circle", "CircleLine", "BpmnEventTimer", "Cloud", "Club", "Component", "Cone1", "Cone2", "Crescent", "Cube1", "Cube2", "Cylinder1", "Cylinder2",
                            "Cylinder3", "Cylinder4", "Decagon", "Diamond", "Dodecagon", "EightPointedBurst", "EightPointedStar", "Ellipse", "Email", "EmptyDrink", "FireHazard", "FivePointedBurst", "FivePointedStar",
                            "Flag", "FramedRectangle", "Drink", "Gear", "HalfEllipse", "Hand", "Heart", "Heptagon", "Hexagon", "HourGlass", "Key", "Location", "Lock", "Map", "NinePointedBurst", "NinePointedStar", "Nonagon",
                            "Octagon",
                            "Parallelogram1", "Parallelogram2", "Pentagon", "Actor", "Pie", "PiePiece", "Plane", "Prism1", "Prism2", "Pyramid1", "Pyramid2", "Rectangle", "RightTriangle", "Ring", "RoundedIBeam",
                            "RoundedRectangle", "SevenPointedBurst", "SevenPointedStar", "SixPointedBurst", "SixPointedStar", "Spade", "SpeechBubble", "Square", "SquareArrow", "TenPointedBurst", "TenPointedStar",
                            "ThickCross", "ThickX", "Trapezoid", "TriangleDown", "TriangleLeft", "TriangleRight", "TriangleUp", "TruckShipment", "Unlocked", "Warehouse"];
                    }
                },
                "key": {show: false},
                "id": {show: false},
                "from": {show: false},
                "to": {show: false},
                "forward": {show: false},
                "reverse": {show: false},
                "relationship_name": {show: false},
                "location": {show: false},
                "visible": {show: false},
                "isDeleted": {show: false},
                "isChanged": {show: false},
                "height": {show: false},
                "width": {show: false},
                "routing": {show: false},
                "angle": {show: false},
                "uid": {show: false},
                "attributes": {show: false},
                "labelVisible": {show: false},
                "isAdded": {show: false},
                "points": {show: false}
            }
        });

        let linkInspector = new Inspector("linkInspector", myDiagram, {
            properties: {
                "relationship_name": {show: Inspector.showIfLink && Inspector.showIfPresent},
                "forward": {show: Inspector.showIfLink && Inspector.showIfPresent},
                "reverse": {show: Inspector.showIfLink && Inspector.showIfPresent},
                "systemRequired": {
                    show: Inspector.showIfLink, type: "select", choices: function (node, propName) {
                        return ["true", "false"];
                    }
                },
                "routing": {
                    show: Inspector.showIfPresent, type: "select",
                    choices: ["Normal", "Orthogonal", "AvoidsNodes"]
                },
                "key": {show: false},
                "id": {show: false},
                "from": {show: false},
                "to": {show: false},
                "name": {show: false},
                "description": {show: false,},
                "color": {show: false},
                "location": {show: false},
                "visible": {show: false},
                "isDeleted": {show: false},
                "isChanged": {show: false},
                "shape": {show: false},
                "height": {show: false},
                "width": {show: false},
                "angle": {show: false},
                "fontColor": {show: false},
                "uid": {show: false},
                "attributes": {show: false},
                "labelVisible": {show: false},
                "isAdded": {show: false},
                "points": {show: false}
            }
        });

        jQuery("#delete_relationship_btn").off("click").on("click", (e) => {
            e.preventDefault();
            objectsChanged = true;
            let diagramLink = myDiagram.findLinkForData(myDiagram.selection.fa.value.jb);
            let link = jQuery.extend(true, {}, diagramLink);
            link.jb.visible = false;
            link.jb.isChanged = false;
            link.jb.isDeleted = true;
            myDiagram.remove(diagramLink);
            if (link.jb.id != -1) {
                links.find(s => s.uid == link.jb.uid).visible = false;
                links.find(s => s.uid == link.jb.uid).isDeleted = true;
                links.find(s => s.uid == link.jb.uid).isChanged = false;
            } else {
                let lk = links.findIndex(s => s.id == link.jb.id);
                if (lk != -1) {
                    links.splice(lk, 1);
                }
            }
            myDiagram.clearSelection();
            selectionChanged();
        });

        function updateLinkInDiagram(findLink, model, linkData, fromNode, toNode, relation, changedList) {
            if (findLink == null || findLink.count == 0) {
                model.setFromKeyForLinkData(linkData, model.getKeyForNodeData(fromNode.jb));
                model.setToKeyForLinkData(linkData, model.getKeyForNodeData(toNode.jb));
                model.addLinkData(linkData);
            } else {
                findLink.fg.fa.value.jb.visible = true;
            }

            let linkModel = links.find(s => s.id == relation.id);
            if (linkModel != null && linkModel != undefined) {
                linkModel.visible = true;
            } else {
                links.push(jQuery.extend({}, true, myDiagram.findLinkForData(linkData).jb));
            }
            let changedLinkIndex = changedList.findIndex(s => s.id == relation.id && s.type == LAYOUT_OBJECT_TYPES.REL);
            if (changedLinkIndex != -1) {
                changedList.splice(changedLinkIndex, 1);
            }
        }

        jQuery("#layout_update_btn").off("click").on("click", (e) => {
            e.preventDefault();
            const rows = self.state.selectedHidden;
            let boList = [];
            let relList = [];
            let model = myDiagram.model;
            let changedList = JSON.parse(JSON.stringify(changedNodes));

            rows.forEach(row => {
                if (row.type == LAYOUT_OBJECT_TYPES.BO) {
                    boList.push(row);
                } else if (row.type == LAYOUT_OBJECT_TYPES.REL) {
                    relList.push(row);
                }
            });

            let promise = new Promise((resolve, reject) => {
                if (boList.length > 0) {
                    boList.forEach((item, index, array) => {
                        switch (item.state) {
                            case LAYOUT_OBJECT_STATES.hidden:
                                let diagramNode = myDiagram.findNodesByExample({id: item.id});
                                if (diagramNode == null || diagramNode.count == 0) {
                                    let nodeData = model.copyNodeData({
                                        key: item.name,
                                        id: item.id,
                                        name: data.find(s => s.id == item.id) != null ? data.find(s => s.id == item.id).name : item.name,
                                        description: data.find(s => s.id == item.id) != null ? data.find(s => s.id == item.id).description : item.description,
                                        color: item.color != null ? item.color : go.Brush.randomColor(),
                                        visible: true,
                                        shape: item.shape != null ? item.shape : GOJS_SELECT_CHOICES.Circle,
                                        height: item.height != null ? item.height : "auto",
                                        width: item.width != null ? item.width : "auto",
                                        angle: item.angle != null ? item.angle : 0,
                                        location: item.location != null
                                            ? new go.Point(item.location.x, item.location.y)
                                            : new go.Point((Math.random() * (myDiagram.documentBounds.right - myDiagram.documentBounds.left) + myDiagram.documentBounds.left),
                                                (Math.random() * (myDiagram.documentBounds.bottom - myDiagram.documentBounds.top) + myDiagram.documentBounds.top)),
                                        fontColor: item.fontColor != null ? item.fontColor : '#000',
                                        systemRequired: item.systemRequired != null ? item.systemRequired : false,
                                        attributes: data.find(s => s.id == item.id) != null ? Array.from(data.find(s => s.id == item.id).attributes.values()).sort((a, b) => a.name.localeCompare(b.name)) : []
                                    });
                                    model.addNodeData(nodeData);
                                } else {
                                    diagramNode.fg.fa.value.jb.visible = true;
                                }

                                let modelNode = nodes.find(s => s.id == item.id);
                                if (modelNode != null) {
                                    modelNode.visible = true;
                                } else {
                                    nodes.push(jQuery.extend({}, true, myDiagram.findNodeForKey(item.name)).jb);
                                }

                                data.forEach(value => {
                                    let relationships = Array.from(value.relationships.values());
                                    let relations = Array.from(relationships.filter(s => s.fromBoClass.id == item.id || s.toBoClass.id == item.id));
                                    relations.forEach(relation => {
                                        if (model.nodeDataArray.find(s => s.id == relation.fromBoClass.id && s.visible) != null &&
                                            model.nodeDataArray.find(p => p.id == relation.toBoClass.id && p.visible) != null) {
                                            let fromNode = myDiagram.findNodeForKey(nodes.find(s => s.id == relation.fromBoClass.id).key);
                                            let toNode = myDiagram.findNodeForKey(nodes.find(s => s.id == relation.toBoClass.id).key);
                                            let findLink = myDiagram.findLinksByExample({id: relation.id});
                                            let linkData = model.copyLinkData({
                                                id: relation.id,
                                                from: fromNode.key,
                                                to: toNode.key,
                                                relationship_name: relation.name,
                                                forward: relation.inward,
                                                reverse: relation.outward,
                                                visible: true,
                                                labelVisible: showLabels,
                                                routing: "Normal",
                                                systemRequired: relation.systemRequired
                                            });
                                            updateLinkInDiagram(findLink, model, linkData, fromNode, toNode, relation, changedList);
                                        }
                                    })
                                });
                                let changedIndex = changedList.findIndex(s => s.id == item.id && s.type == item.type && s.state == item.state);
                                if (changedIndex != -1) {
                                    changedList.splice(changedIndex, 1);
                                    if (changedList.length == 0) {
                                        changedList = [];
                                    }
                                }
                                break;
                            default:
                                break;
                        }

                        if (item.state == LAYOUT_OBJECT_STATES.created && item.type == LAYOUT_OBJECT_TYPES.BO) {
                            let nodeData = model.copyNodeData({
                                key: item.name,
                                id: item.id,
                                name: item.name,
                                description: item.description,
                                color: go.Brush.randomColor(),
                                visible: true,
                                shape: GOJS_SELECT_CHOICES.Circle,
                                height: "auto",
                                width: "auto",
                                angle: 0,
                                fontColor: '#000',
                                location: new go.Point((Math.random() * (myDiagram.documentBounds.right - myDiagram.documentBounds.left) + myDiagram.documentBounds.left),
                                    (Math.random() * (myDiagram.documentBounds.bottom - myDiagram.documentBounds.top) + myDiagram.documentBounds.top)),
                                systemRequired: item.systemRequired != null ? item.systemRequired : false,
                                attributes: data.find(s => s.id == item.id) != null ? Array.from(data.find(s => s.id == item.id).attributes.values()).sort((a, b) => a.name.localeCompare(b.name)) : []
                            });
                            model.addNodeData(nodeData);
                            let modelNode = nodes.find(s => s.id == item.id);
                            if (modelNode != null) {
                                modelNode = jQuery.extend({}, true, myDiagram.findNodeForKey(item.name).jb);
                            } else {
                                nodes.push(jQuery.extend({}, true, myDiagram.findNodeForKey(item.name).jb));
                            }

                            data.forEach(value => {
                                let relationships = Array.from(value.relationships.values());
                                let relations = Array.from(relationships.filter(s => s.fromBoClass.id == item.id || s.toBoClass.id == item.id));
                                relations.forEach(relation => {
                                    if (model.nodeDataArray.find(s => s.id == relation.fromBoClass.id && s.visible) != null &&
                                        model.nodeDataArray.find(p => p.id == relation.toBoClass.id && p.visible) != null) {
                                        let fromNode = myDiagram.findNodeForKey(nodes.find(s => s.id == relation.fromBoClass.id).key);
                                        let toNode = myDiagram.findNodeForKey(nodes.find(s => s.id == relation.toBoClass.id).key);
                                        let findLink = myDiagram.findLinksByExample({id: relation.id});
                                        let linkData = model.copyLinkData({
                                            id: relation.id,
                                            from: fromNode.key,
                                            to: toNode.key,
                                            relationship_name: relation.name,
                                            forward: relation.inward,
                                            reverse: relation.outward,
                                            visible: true,
                                            labelVisible: showLabels,
                                            routing: "Normal"
                                        });
                                        updateLinkInDiagram(findLink, model, linkData, fromNode, toNode, relation, changedList);
                                    }
                                })
                            });

                            let changedIndex = changedList.findIndex(s => s.id == item.id && s.type == item.type && s.state == item.state);
                            if (changedIndex != -1) {
                                changedList.splice(changedIndex, 1);

                                if (changedNodes.length == 0) {
                                    changedNodes = [];
                                }
                            }
                        }
                        if (index == array.length - 1) {
                            resolve();
                        }
                    });
                } else {
                    resolve();
                }
                resolve();
            });

            let promiseRel = new Promise((resolve, reject) => {
                promise.then(() => {
                    if (relList.length > 0) {
                        relList.forEach((item, index, array) => {
                            switch (item.state) {
                                case LAYOUT_OBJECT_STATES.hidden:
                                    let diagramLink = myDiagram.findLinksByExample({id: item.id});
                                    let linkData = model.copyLinkData({
                                        id: item.id,
                                        relationship_name: item.relationship_name,
                                        visible: true,
                                        from: item.from,
                                        to: item.to,
                                        forward: item.forward,
                                        reverse: item.reverse,
                                        routing: item.routing,
                                        labelVisible: showLabels,
                                        uid: shortid.generate(),
                                        points: item.points,
                                        systemRequired: item.systemRequired != null ? item.systemRequired : false
                                    });
                                    if (diagramLink == null || diagramLink.count == 0) {
                                        if (myDiagram.findNodeForKey(item.from) != null && myDiagram.findNodeForKey(item.to) != null) {
                                            model.setFromKeyForLinkData(linkData, item.from);
                                            model.setToKeyForLinkData(linkData, item.to);
                                            model.addLinkData(linkData);
                                        } else {
                                            toastr.warning("Relationship could not be added as one of the business objects is not visible.");
                                            return false;
                                        }
                                    } else {
                                        diagramLink.fg.fa.value.jb.visible = true;
                                    }
                                    let changedIndex = changedList.findIndex(s => s.id == item.id && s.type == LAYOUT_OBJECT_TYPES.REL);
                                    if (changedIndex != -1) {
                                        changedList.splice(changedIndex, 1);
                                    }
                                    let modelLink = links.find(s => s.id == item.id);
                                    if (modelLink != null) {
                                        modelLink.visible = true;
                                    } else {
                                        links.push(jQuery.extend({}, true, myDiagram.findLinkForData(linkData)).jb);
                                    }
                                    break;
                                default:
                                    break;
                            }

                            if (item.state == LAYOUT_OBJECT_STATES.created && item.type == LAYOUT_OBJECT_TYPES.REL) {
                                let visible = true;
                                let fromNode = nodes.find(f => f.name == item.from);
                                let toNode = nodes.find(t => t.name == item.to);
                                if (fromNode == null) {
                                    toastr.warning("Relationship could not be added because business object " + item.from + " is not visible. Add the business object first.");
                                    return false;
                                } else if (toNode == null) {
                                    toastr.warning("Relationship could not be added because business object " + item.to + " is not visible. Add the business object first.");
                                    return false;
                                } else {
                                    if (!fromNode.visible || !toNode.visible) {
                                        visible = false;
                                    }

                                    let linkData = model.copyLinkData({
                                        id: item.id,
                                        relationship_name: item.relationship_name,
                                        forward: item.forward,
                                        from: item.from,
                                        to: item.to,
                                        reverse: item.reverse,
                                        visible: visible,
                                        routing: "Normal",
                                        labelVisible: showLabels,
                                        uid: shortid.generate(),
                                        points: item.points,
                                        systemRequired: item.systemRequired != null ? item.systemRequired : false
                                    });

                                    if (visible) {
                                        model.setFromKeyForLinkData(linkData, item.from);
                                        model.setToKeyForLinkData(linkData, item.to);
                                        model.addLinkData(linkData);
                                        let modelLink = links.find(s => s.id == item.id);
                                        if (modelLink != null) {
                                            modelLink = jQuery.extend({}, true, linkData);
                                        } else {
                                            links.push(jQuery.extend({}, true, linkData));
                                        }
                                    } else {
                                        links.push(jQuery.extend({}, true, linkData));
                                    }

                                    let changedIndex = changedList.findIndex(s => s.id == item.id && s.type == LAYOUT_OBJECT_TYPES.REL);
                                    if (changedIndex != -1) {
                                        changedList.splice(changedIndex, 1);
                                    }
                                }
                            }
                            if (index == array.length - 1) {
                                resolve();
                            }
                        });
                    } else {
                        resolve();
                    }
                    resolve();
                });
            });

            promiseRel.then(() => {
                allowUpdate = false;
                changedNodes = Array.from(changedList);
                self.props.setHiddenAndModifiedBOCsForLayout(Array.from(changedList));
            });

            jQuery("#layout_update_btn").prop("disabled", true);
        });
    };

    saveDiagram(e) {
        e.preventDefault();
        let layoutName = this.props.currentLayout != null ? this.props.currentLayout.name : "";
        let divStyle = this.props.currentLayout != null ? "display:inline-block" : "display:none";
        if (objectsChanged) {
            toastr.warning("Objects changed. Please save objects first.");
            return false;
        }
        confirm = $.confirm({
            title: 'Diagram name',
            keyboardEnabled: true,
            escapeKey: 'cancel',
            backgroundDismiss: true,
            content: '<div style="' + divStyle + '"><label for="create_new">' +
                '<input type="checkbox" id="create_new" name="create_new">Create new diagram' +
                '</label></div>' +
                '<input style="width:100%" id="layout_name" placeholder="Diagram name" value="' + layoutName + '" />',
            buttons: {
                ok: {
                    text: "Save Diagram",
                    btnClass: 'btn-primary btn',
                    keys: ['enter'],
                    action: () => {
                        confirm = null;
                        autoCurrentLayout = false;
                        let layoutName = jQuery(document).find("#layout_name").val();
                        if (!layoutName || myxss.process(layoutName.trim()) == "") {
                            toastr.error('Provide a valid diagram name.');
                            return false;
                        }
                        let layout = {};
                        let layoutNodes = [];
                        myDiagram.nodes.each(function (n) {
                            if (n.jb.id != -1) {
                                let node = {
                                    businessObjectClass:
                                        {
                                            id: n.jb.id,
                                            name: n.jb.name,
                                            description: n.jb.description
                                        },
                                    layout:
                                        {
                                            key: n.jb.key,
                                            id: n.jb.id,
                                            color: n.jb.color,
                                            location: {x: n.le.F, y: n.le.G},
                                            visible: n.jb.visible,
                                            shape: n.jb.shape,
                                            height: n.jb.height,
                                            width: n.jb.width,
                                            angle: n.jb.angle,
                                            fontColor: n.jb.fontColor,
                                            systemRequired: n.jb.systemRequired,
                                            relationships: []
                                        }
                                };
                                layoutNodes.push(node);
                            }
                        });
                        let myModelNodes = Array.from(JSON.parse(JSON.stringify(nodes)));
                        let myModelLinks = Array.from(JSON.parse(JSON.stringify(links)));
                        myModelNodes.forEach(m => {
                            if (m.visible == false && (m.isDeleted == false || m.isDeleted == null) && m.id != -1) {
                                let node = {
                                    businessObjectClass:
                                        {
                                            id: m.id,
                                            name: m.name,
                                            description: m.description
                                        },
                                    layout:
                                        {
                                            key: m.key,
                                            id: m.id,
                                            color: m.color,
                                            location: m.location,
                                            visible: false,
                                            shape: m.shape,
                                            height: m.height,
                                            width: m.width,
                                            angle: m.angle,
                                            fontColor: m.fontColor,
                                            systemRequired: m.systemRequired,
                                            relationships: []
                                        }
                                };
                                if (layoutNodes.findIndex(s => s.layout.id == m.id) == -1) {
                                    layoutNodes.push(node);
                                }
                            }
                        });
                        myModelLinks.forEach(link => {
                            if (link.id != -1 && link.isDeleted != true) {
                                let lNode = layoutNodes.find(s => s.layout.key == link.from);
                                let toNode = layoutNodes.find(s => s.layout.key == link.to);
                                let visible = true;
                                if (toNode != null && lNode != null) {
                                    visible = lNode.layout.visible && toNode.layout.visible;
                                } else {
                                    visible = false;
                                }
                                let relation = {
                                    id: link.id,
                                    relationship_name: link.relationship_name,
                                    from: link.from,
                                    to: link.to,
                                    reverse: link.reverse,
                                    forward: link.forward,
                                    routing: link.routing,
                                    visible: !visible ? false : link.visible,
                                    systemRequired: link.systemRequired,
                                    labelVisible: showLabels,
                                    points: link.points
                                };
                                if (lNode != null && lNode != undefined) {
                                    lNode.layout.relationships.push(relation);
                                }
                            }
                        });
                        layout.name = myxss.process(layoutName.trim());
                        layout.businessObjectClassLayouts = layoutNodes;
                        if (this.props.currentLayout != null && !jQuery("#create_new").is(":checked")) {
                            layout.id = this.props.currentLayout.id;
                            this.props.updateBOCLayout(this.props.currentLayout.id, layout);
                        } else {
                            layout.id = -1;
                            this.props.createLayout(layout);
                        }
                    }
                },
                cancel: function () {
                    confirm = null;
                }
            }
        });
    }

    saveBocs() {
        bocToSave = {bocToAdd: [], bocToDelete: [], bocToUpdate: []};
        let {businessObjectsWrapper} = this.props;
        let nodeDataArrayForAdd = Array.from(JSON.parse(JSON.stringify(myDiagram.model.nodeDataArray)));
        let nodesToAdd = nodeDataArrayForAdd.filter(s => s.id == -1 && s.isDeleted != true && s.isAdded != false);
        let bocToAdd = [];

        if (nodesToAdd.length > 0) {
            nodesToAdd.forEach(node => {
                let businessObject = {
                    id: node.id,
                    name: node.name,
                    description: node.description,
                    systemRequired: node.systemRequired
                };
                if (businessObjectsWrapper.hasBusinessObject(businessObject.name.toLowerCase())) {
                    let bo = businessObjectsWrapper.getBusinessObject(businessObject.id);
                    if (bo != null && businessObject.id != bo.id) {
                        toastr.error("Business object with name " + businessObject.name + " already exists.", {
                            timeOut: 0,
                            extendedTimeOut: 0
                        });
                    }
                } else {
                    bocToAdd.push(businessObject);
                }
            });
        }
        bocToSave.bocToAdd = bocToAdd;
        let nodeDataArrayForDelete = Array.from(JSON.parse(JSON.stringify(nodes)));
        let bocToDelete = [];

        let nodesToDelete = nodeDataArrayForDelete.filter(x => x.isDeleted == true && x.id != -1);
        if (nodesToDelete.length > 0) {
            nodesToDelete.forEach(node => {
                let businessObject = {
                    id: node.id,
                    name: node.name,
                    description: node.description,
                    systemRequired: node.systemRequired
                };
                if (businessObjectsWrapper.hasBusinessObject(businessObject.id)) {
                    let bo = businessObjectsWrapper.getBusinessObject(businessObject.id);
                    if (!bo.isErasable()) {
                        toastr.error("Business object with name " + businessObject.name + " is non-removable.", {
                            timeOut: 0,
                            extendedTimeOut: 0
                        });
                    } else {
                        bocToDelete.push(businessObject.id);
                    }
                }
            });
        }
        bocToSave.bocToDelete = bocToDelete;
        let nodeDataArrayForUpdate = Array.from(JSON.parse(JSON.stringify(nodes)));
        let nodesToUpdate = nodeDataArrayForUpdate.filter(x => x.isChanged == true && x.id != -1);
        let bocToUpdate = [];

        nodesToUpdate
            .forEach(node => {
                let businessObject = {
                    id: node.id,
                    name: node.name,
                    description: node.description,
                    systemRequired: node.systemRequired
                };
                if (businessObjectsWrapper.hasBusinessObject(businessObject.name)) {
                    let bo = businessObjectsWrapper.getBusinessObject(businessObject.name.toLowerCase());
                    if (bo != null && businessObject.id != bo.id) {
                        toastr.error("Business object with name " + businessObject.name + " already exists.", {
                            timeOut: 0,
                            extendedTimeOut: 0
                        });
                    } else {
                        bocToUpdate.push(businessObject);
                    }
                } else {
                    bocToUpdate.push(businessObject);
                }
            });

        bocToSave.bocToUpdate = bocToUpdate;
        return bocToSave;
    }

    saveRelationships() {
        relToSave = {relToAdd: [], relToDelete: [], relToUpdate: []};
        let linkDataArrayForAdd = Array.from(JSON.parse(JSON.stringify(myDiagram.model.linkDataArray)));
        let linksAdded = linkDataArrayForAdd.filter(x => x.id == -1);
        let relToAdd = [];
        allowUpdate = false;
        linksAdded.forEach(link => {
            let fromNode = myDiagram.findNodeForKey(link.from);
            let toNode = myDiagram.findNodeForKey(link.to);

            relToAdd.push({
                name: link.relationship_name,
                inward: link.forward,
                outward: link.reverse,
                systemRequired: link.systemRequired,
                fromBoClass: {id: fromNode.jb.id, name: fromNode.jb.name, description: fromNode.jb.description},
                toBoClass: {id: toNode.jb.id, name: toNode.jb.name, description: toNode.jb.description},
            });
        });
        relToSave.relToAdd = relToAdd;
        let linkDataArrayForDelete = Array.from(JSON.parse(JSON.stringify(links)));
        let linksDeleted = linkDataArrayForDelete.filter(x => x.isDeleted == true && x.id != -1);
        let relToDelete = [];
        linksDeleted.forEach(link => {
            relToDelete.push(link.id);
        });
        relToSave.relToDelete = relToDelete;

        let linkDataArray = Array.from(JSON.parse(JSON.stringify(links)));
        let linksToUpdate = linkDataArray.filter(x => x.isChanged == true && x.id != -1);
        let relToUpdate = [];
        linksToUpdate.forEach(link => {
            relToUpdate.push({
                id: link.id,
                name: link.relationship_name,
                inward: link.forward,
                outward: link.reverse,
                systemRequired: link.systemRequired
            });
        });
        relToSave.relToUpdate = relToUpdate;
        return relToSave;
    }

    saveObjects(e) {
        e.preventDefault();
        allowUpdate = false;
        autoCurrentLayout = false;
        let saveModel = {
            create: {boc: [], relType: []},
            delete: {boc: [], relType: []},
            update: {boc: [], relType: []}
        };

        let bocToSave = this.saveBocs();
        let relToSave = this.saveRelationships();

        if (bocToSave && relToSave) {
            saveModel.create.boc = bocToSave.bocToAdd;
            saveModel.update.boc = bocToSave.bocToUpdate;
            saveModel.delete.boc = bocToSave.bocToDelete;
            saveModel.create.relType = relToSave.relToAdd;
            saveModel.update.relType = relToSave.relToUpdate;
            saveModel.delete.relType = relToSave.relToDelete;
        } else {
            if (myDiagram != null) {
                myDiagram.div = null;
                myDiagram = null;
            }
            nodes = [];
            links = [];
            objectsChanged = false;

            this.init(this.props.businessObjectsWrapper);
        }

        if (saveModel.create.boc.length > 0 || saveModel.create.relType.length > 0 || saveModel.update.boc.length > 0
            || saveModel.update.relType.length > 0 || saveModel.delete.relType.length > 0 || saveModel.delete.boc.length > 0) {
            objectsChanged = false;
            this.props.layoutSaveObjects(saveModel);
        }
    }

    printDiagram(e) {
        e.preventDefault();

        let imgDiv = document.createElement('div');
        imgDiv.innerHTML = ''; // clear out the old images, if any
        let db = myDiagram.documentBounds.copy();
        let imgWidth = db.width;
        let imgHeight = db.height;
        let p = db.position.copy();

        let img = myDiagram.makeImage({
            scale: 1,
            position: new go.Point(p.x, p.y),
            size: new go.Size(imgWidth, imgHeight)
        });
        // Append the new HTMLImageElement to the div
        img.className = 'images';
        imgDiv.appendChild(img);
        imgDiv.appendChild(document.createElement('br'));

        let popupWin = window.open('', '_blank', 'top=0, left=0, height=100%, width=auto');
        popupWin.document.open();
        popupWin.document.write(`
          <html>
            <head>
              <title>Business Object Relations</title>
              <style>
                @media print and (width:11in) and (height: 8.3in) {
                    @page {
                        margin: 1.1in;
                        width: 11in;
                        height: 8.3in;                       
                    }
                }
            </style>
            </head>           
             <body onload="window.print();window.close();">` + imgDiv.innerHTML + `</body>
           </html>`
        );
        popupWin.document.close();
    }

    deleteLayout(e) {
        e.preventDefault();
        confirm = $.confirm({
            title: 'Confirm?',
            keyboardEnabled: true,
            escapeKey: 'cancel',
            backgroundDismiss: true,
            content: 'You are about to delete a diagram, this procedure is irreversible.',
            type: 'red',
            buttons: {
                ok: {
                    text: "Yes!",
                    btnClass: 'btn-danger',
                    keys: ['enter'],
                    action: () => {
                        confirm = null;
                        autoCurrentLayout = false;
                        let selected = JSON.parse(jQuery('#layout_select').val());
                        selectedVal = JSON.stringify({
                            id: -1,
                            name: "Full diagram (auto)"
                        });
                        jQuery('#layout_select').val(selectedVal).trigger("change");
                        this.props.deleteBOCLayout(selected.id);
                        this.props.setCurrentBOCLayout(null);
                    }
                },
                cancel: function () {
                    confirm = null;
                }
            }
        });
    }

    resizeToFitBrowserWindow(diagram, inspectData) {
        $('.left_panel').width(diagram + 3);
        $('.right_panel').width(inspectData + 3);
    };

    addActiveClass() {
        let $layoutPopover = $("#layout-info-popover");
        if ($layoutPopover.hasClass("active")) {
            $layoutPopover.removeClass("active")
        } else {
            $layoutPopover.addClass("active")
        }
    };

    zoomToFit() {
        myDiagram.commandHandler.zoomToFit();
    }

    zoomIn() {
        myDiagram.commandHandler.increaseZoom();
    }

    zoomOut() {
        myDiagram.commandHandler.decreaseZoom();
    }

    toggleLabels() {
        showLabels = !showLabels;
        if (!showLabels) {
            jQuery("#toggle_link_labels_diagram_btn").html("<i class='fas fa-toggle-off fa-sm'/><span> Show Link Labels</span>");
        } else {
            jQuery("#toggle_link_labels_diagram_btn").html("<i class='fas fa-toggle-on fa-sm'/><span> Hide Link Labels</span>");
        }
        myDiagram.links.each(link => {
            let label = link.findObject("LABEL");
            label.visible = showLabels;
            link.jb.labelVisible = showLabels;
        });
    }

    toggleSysObjects() {
        myDiagram.clearSelection();
        systemObjectsToggle = true;
        let {hiddenAndModifiedBOCsForLayout, businessObjectsWrapper} = this.props;
        const data = businessObjectsWrapper.getBusinessObjects(DataTypesEnum.ARRAY);
        let updatedBOCs = JSON.parse(JSON.stringify(hiddenAndModifiedBOCsForLayout));
        showSysObjects = !showSysObjects;
        let diagramNodesToRemove = [];
        if (!showSysObjects) {
            myDiagram.nodes.each(node => {
                if (node.jb.systemRequired) {
                    node.visible = false;
                    node.jb.visible = false;
                    if (fullLayout != null) {
                        fullLayout.nodes.find(s => s.key == node.jb.key).visible = false;
                        fullLayout.nodes.find(s => s.key == node.jb.key).isDeleted = false;
                    }
                    let hiddenBOC = updatedBOCs.find(s => s.id == node.jb.id && s.type == LAYOUT_OBJECT_TYPES.BO);
                    if (!hiddenBOC) {
                        updatedBOCs.push({
                            id: node.jb.id,
                            name: node.jb.name,
                            key: node.jb.key,
                            description: node.jb.description,
                            state: LAYOUT_OBJECT_STATES.hidden,
                            type: LAYOUT_OBJECT_TYPES.BO,
                            shape: node.jb.shape,
                            height: node.jb.height,
                            width: node.jb.width,
                            angle: node.jb.angle,
                            fontColor: node.jb.fontColor,
                            location: node.location,
                            color: node.jb.color,
                            uniqueId: node.jb.name + ", id:  " + node.jb.id,
                            systemRequired: node.jb.systemRequired
                        });
                    }
                    if (nodes.length > 0) {
                        nodes.find(s => s.id == node.jb.id).visible = false;
                        nodes.find(s => s.id == node.jb.id).isDeleted = false;
                    }

                    let hiddenLinks = links.filter(s => s.from == node.jb.key || s.to == node.jb.key);
                    hiddenLinks.forEach(hl => {
                        if (hl.id != -1 && updatedBOCs.findIndex(s => s.id == hl.id && s.type == LAYOUT_OBJECT_TYPES.REL) == -1) {
                            updatedBOCs.push({
                                id: hl.id,
                                relationship_name: hl.relationship_name,
                                state: LAYOUT_OBJECT_STATES.hidden,
                                type: LAYOUT_OBJECT_TYPES.REL,
                                from: hl.from,
                                to: hl.to,
                                forward: hl.forward,
                                reverse: hl.reverse,
                                routing: hl.routing,
                                uid: hl.uid,
                                labelVisible: showLabels,
                                uniqueId: hl.from + " " + hl.forward + " " + hl.to,
                                points: hl.points,
                                systemRequired: hl.systemRequired
                            });
                        }
                        hl.visible = false;
                    });
                    diagramNodesToRemove.push(node);
                }
            });

            diagramNodesToRemove.forEach(n => {
                myDiagram.remove(n);
            });

            myDiagram.links.each(link => {
                if (link.jb.systemRequired) {
                    link.visible = false;
                    link.jb.visible = false;
                    let hiddenLink = updatedBOCs.find(s => s.id == link.jb.id && s.type == LAYOUT_OBJECT_TYPES.REL);
                    if (!hiddenLink) {
                        updatedBOCs.push({
                            id: link.jb.id,
                            relationship_name: link.jb.relationship_name,
                            state: LAYOUT_OBJECT_STATES.hidden,
                            type: LAYOUT_OBJECT_TYPES.REL,
                            from: link.jb.from,
                            to: link.jb.to,
                            forward: link.jb.forward,
                            reverse: link.jb.reverse,
                            routing: link.jb.routing,
                            uid: link.jb.uid,
                            labelVisible: showLabels,
                            uniqueId: link.jb.from + " " + link.jb.forward + " " + link.jb.to,
                            systemRequired: link.jb.systemRequired,
                            points: link.jb.points
                        });
                    }
                    if (links.length > 0) {
                        links.find(s => s.id == link.jb.id).visible = false;
                    }
                }
            });
            allowUpdate = false;
            jQuery("#toggle_sys_objects_btn").html("<i class='fas fa-toggle-off fa-sm'/><span> Show System Objects</span>");
            let updateNodes = new Promise((resolve, reject) => {
                this.props.setHiddenAndModifiedBOCsForLayout(Array.from(updatedBOCs));
            });
            updateNodes.then(() => {
                allowUpdate = true;
            });
            myDiagram.clearSelection();

        } else {
            myDiagram.nodes.each(node => {
                if (node.jb.systemRequired) {
                    node.visible = true;
                    node.jb.visible = true;
                }
            });
            myDiagram.links.each(link => {
                if (link.jb.systemRequired) {
                    link.visible = true;
                    link.jb.visible = true;
                }
            });

            let changedList = JSON.parse(JSON.stringify(this.props.hiddenAndModifiedBOCsForLayout));
            let boList = [];
            let relList = [];

            changedList.forEach(s => {
                if (s.type == LAYOUT_OBJECT_TYPES.BO && s.systemRequired) {
                    boList.push(s);
                } else if (s.type == LAYOUT_OBJECT_TYPES.REL && s.systemRequired) {
                    relList.push(s);
                }
            });

            let promise = new Promise((resolve, reject) => {
                if (boList.length > 0) {
                    boList.forEach((item, index, array) => {
                        switch (item.state) {
                            case LAYOUT_OBJECT_STATES.hidden:
                                if (item.systemRequired) {
                                    let diagramNode = myDiagram.findNodesByExample({id: item.id});
                                    if (diagramNode == null || diagramNode.count == 0) {
                                        let nodeData = myDiagram.model.copyNodeData({
                                            key: item.name,
                                            id: item.id,
                                            name: data.find(s => s.id == item.id) != null ? data.find(s => s.id == item.id).name : item.name,
                                            description: data.find(s => s.id == item.id) != null ? data.find(s => s.id == item.id).description : item.description,
                                            color: item.color != null ? item.color : go.Brush.randomColor(),
                                            visible: true,
                                            shape: item.shape != null ? item.shape : GOJS_SELECT_CHOICES.Circle,
                                            height: item.height != null ? item.height : "auto",
                                            width: item.width != null ? item.width : "auto",
                                            angle: item.angle != null ? item.angle : 0,
                                            location: item.location != null
                                                ? new go.Point(item.location.x, item.location.y)
                                                : new go.Point((Math.random() * (myDiagram.documentBounds.right - myDiagram.documentBounds.left) + myDiagram.documentBounds.left),
                                                    (Math.random() * (myDiagram.documentBounds.bottom - myDiagram.documentBounds.top) + myDiagram.documentBounds.top)),
                                            fontColor: item.fontColor != null ? item.fontColor : '#000',
                                            systemRequired: item.systemRequired,
                                            attributes: data.find(s => s.id == item.id) != null ? Array.from(data.find(s => s.id == item.id).attributes.values()).sort((a, b) => a.name.localeCompare(b.name)) : []
                                        });
                                        myDiagram.model.addNodeData(nodeData);
                                    } else {
                                        // diagramNode.bi.fa.value.visible = true;
                                        diagramNode.fg.fa.value.jb.visible = true;
                                    }

                                    let modelNode = nodes.find(s => s.id == item.id);
                                    if (modelNode != null) {
                                        modelNode.visible = true;
                                    } else {
                                        nodes.push(jQuery.extend({}, true, myDiagram.findNodeForKey(item.name)).jb);
                                    }

                                    data.forEach(value => {
                                        let relationships = Array.from(value.relationships.values());
                                        let relations = Array.from(relationships.filter(s => s.fromBoClass.id == item.id || s.toBoClass.id == item.id));
                                        relations.forEach(relation => {
                                            if (myDiagram.model.nodeDataArray.find(s => s.id == relation.fromBoClass.id && s.visible) != null &&
                                                myDiagram.model.nodeDataArray.find(p => p.id == relation.toBoClass.id && p.visible) != null) {
                                                let fromNode = myDiagram.findNodeForKey(nodes.find(s => s.id == relation.fromBoClass.id).key);
                                                let toNode = myDiagram.findNodeForKey(nodes.find(s => s.id == relation.toBoClass.id).key);
                                                let findLink = myDiagram.findLinksByExample({id: relation.id});
                                                let linkData = myDiagram.model.copyLinkData({
                                                    id: relation.id,
                                                    from: fromNode.key,
                                                    to: toNode.key,
                                                    relationship_name: relation.name,
                                                    forward: relation.inward,
                                                    reverse: relation.outward,
                                                    visible: true,
                                                    labelVisible: showLabels,
                                                    routing: "Normal",
                                                    systemRequired: relation.systemRequired,
                                                    points: []
                                                });
                                                if (findLink == null || findLink.count == 0) {
                                                    myDiagram.model.setFromKeyForLinkData(linkData, myDiagram.model.getKeyForNodeData(fromNode.jb));
                                                    myDiagram.model.setToKeyForLinkData(linkData, myDiagram.model.getKeyForNodeData(toNode.jb));
                                                    myDiagram.model.addLinkData(linkData);
                                                } else {
                                                    findLink.fg.fa.value.jb.visible = true;
                                                }

                                                let linkModel = links.find(s => s.id == relation.id);
                                                if (linkModel != null && linkModel != undefined) {
                                                    linkModel.visible = true;
                                                } else {
                                                    links.push(jQuery.extend({}, true, myDiagram.findLinkForData(linkData).jb));
                                                }
                                                let changedLinkIndex = changedList.findIndex(s => s.id == relation.id && s.type == LAYOUT_OBJECT_TYPES.REL);
                                                if (changedLinkIndex != -1) {
                                                    changedList.splice(changedLinkIndex, 1);
                                                }
                                            }
                                        })
                                    });
                                    let changedIndex = changedList.findIndex(s => s.id == item.id && s.type == item.type && s.state == item.state);
                                    if (changedIndex != -1) {
                                        changedList.splice(changedIndex, 1);
                                        if (changedList.length == 0) {
                                            changedList = [];
                                        }
                                    }
                                }
                                break;
                            default:
                                break;
                        }

                        if (item.state == LAYOUT_OBJECT_STATES.created && item.type == LAYOUT_OBJECT_TYPES.BO && item.systemRequired) {
                            let nodeData = myDiagram.model.copyNodeData({
                                key: item.name,
                                id: item.id,
                                name: item.name,
                                description: item.description,
                                color: go.Brush.randomColor(),
                                visible: true,
                                shape: GOJS_SELECT_CHOICES.Circle,
                                height: "auto",
                                width: "auto",
                                angle: 0,
                                fontColor: '#000',
                                location: new go.Point((Math.random() * (myDiagram.documentBounds.right - myDiagram.documentBounds.left) + myDiagram.documentBounds.left),
                                    (Math.random() * (myDiagram.documentBounds.bottom - myDiagram.documentBounds.top) + myDiagram.documentBounds.top)),
                                systemRequired: item.systemRequired,
                                attributes: data.find(s => s.id == item.id) != null ? Array.from(data.find(s => s.id == item.id).attributes.values()).sort((a, b) => a.name.localeCompare(b.name)) : []
                            });
                            myDiagram.model.addNodeData(nodeData);
                            let modelNode = nodes.find(s => s.id == item.id);
                            if (modelNode != null) {
                                modelNode = jQuery.extend({}, true, myDiagram.findNodeForKey(item.name).jb);
                            } else {
                                nodes.push(jQuery.extend({}, true, myDiagram.findNodeForKey(item.name).jb));
                            }

                            let changedIndex = changedList.findIndex(s => s.id == item.id && s.type == item.type && s.state == item.state);
                            if (changedIndex != -1) {
                                changedList.splice(changedIndex, 1);
                                if (changedList.length == 0) {
                                    changedList = [];
                                }
                            }
                        }
                        if (index == array.length - 1) {
                            resolve();
                        }
                    });
                } else {
                    resolve();
                }
                resolve();
            });

            let promiseRel = new Promise((resolve, reject) => {
                promise.then(() => {
                    if (relList.length > 0) {
                        relList.forEach((item, index, array) => {
                            switch (item.state) {
                                case LAYOUT_OBJECT_STATES.hidden:
                                    if (item.systemRequired) {
                                        let diagramLink = myDiagram.findLinksByExample({id: item.id});
                                        let linkData = myDiagram.model.copyLinkData({
                                            id: item.id,
                                            relationship_name: item.relationship_name,
                                            visible: true,
                                            from: item.from,
                                            to: item.to,
                                            forward: item.forward,
                                            reverse: item.reverse,
                                            routing: item.routing,
                                            labelVisible: showLabels,
                                            uid: shortid.generate(),
                                            systemRequired: item.systemRequired != null ? item.systemRequired : false,
                                            points: item.points
                                        });
                                        if (diagramLink == null || diagramLink.count == 0) {
                                            if (myDiagram.findNodeForKey(item.from) != null && myDiagram.findNodeForKey(item.to) != null) {
                                                myDiagram.model.setFromKeyForLinkData(linkData, item.from);
                                                myDiagram.model.setToKeyForLinkData(linkData, item.to);
                                                myDiagram.model.addLinkData(linkData);
                                            } else {
                                                toastr.warning("Relationship could not be added as one of the business objects is not visible.");
                                                return false;
                                            }
                                        } else {
                                            // diagramLink.bi.fa.value.visible = true;
                                            diagramLink.fg.fa.value.jb.visible = true;
                                        }
                                        let changedIndex = changedList.findIndex(s => s.id == item.id && s.type == LAYOUT_OBJECT_TYPES.REL);
                                        if (changedIndex != -1) {
                                            changedList.splice(changedIndex, 1);
                                        }
                                        let modelLink = links.find(s => s.id == item.id);
                                        if (modelLink != null) {
                                            modelLink.visible = true;
                                        } else {
                                            links.push(jQuery.extend({}, true, myDiagram.findLinkForData(linkData)).jb);
                                        }
                                    }
                                    break;
                                default:
                                    break;
                            }

                            if (item.state == LAYOUT_OBJECT_STATES.created && item.type == LAYOUT_OBJECT_TYPES.REL && item.systemRequired) {
                                let visible = true;
                                let fromNode = nodes.find(f => f.name == item.from);
                                let toNode = nodes.find(t => t.name == item.to);
                                if (fromNode && toNode) {
                                    if (!fromNode.visible || !toNode.visible) {
                                        visible = false;
                                    }

                                    let linkData = myDiagram.model.copyLinkData({
                                        id: item.id,
                                        relationship_name: item.relationship_name,
                                        forward: item.forward,
                                        from: item.from,
                                        to: item.to,
                                        reverse: item.reverse,
                                        visible: visible,
                                        routing: "Normal",
                                        labelVisible: showLabels,
                                        uid: shortid.generate(),
                                        systemRequired: item.systemRequired != null ? item.systemRequired : false,
                                        points: item.points
                                    });

                                    if (visible) {
                                        myDiagram.model.setFromKeyForLinkData(linkData, item.from);
                                        myDiagram.model.setToKeyForLinkData(linkData, item.to);
                                        myDiagram.model.addLinkData(linkData);
                                        let modelLink = links.find(s => s.id == item.id);
                                        if (modelLink != null) {
                                            modelLink = jQuery.extend({}, true, linkData);
                                        } else {
                                            links.push(jQuery.extend({}, true, linkData));
                                        }
                                    } else {
                                        links.push(jQuery.extend({}, true, linkData));
                                    }

                                    let changedIndex = changedList.findIndex(s => s.id == item.id && s.type == LAYOUT_OBJECT_TYPES.REL);
                                    if (changedIndex != -1) {
                                        changedList.splice(changedIndex, 1);
                                    }
                                }
                            }
                            if (index == array.length - 1) {
                                resolve();
                            }
                        });
                    } else {
                        resolve();
                    }
                    resolve();
                });
            });
            allowUpdate = false;
            jQuery("#toggle_sys_objects_btn").html("<i class='fas fa-toggle-on fa-sm'/><span> Hide System Objects</span>");

            promiseRel.then(() => {
                let updateNodes = new Promise((resolve, reject) => {
                    this.props.setHiddenAndModifiedBOCsForLayout(Array.from(changedList));
                });
                updateNodes.then(() => {
                    allowUpdate = true;
                });
            });
            myDiagram.clearSelection();
            jQuery("#layout_update_btn").prop("disabled", true);
        }
    }

    render() {

        let diagramHeight = jQuery("#business_objects_relations").height() - 60;

        const parentStyle = {
            backgroundColor: '#353535',
            border: 'solid 1px black',
            flex: '85%',
            height: diagramHeight || 533
        };
        const diagramStyle = {
            backgroundColor: '#353535',
            border: 'solid 1px black',
            borderBottom: 0,
            height: diagramHeight - 43 || 490
        };
        const detailStyle = {
            backgroundColor: '#353535',
            border: 'solid 1px black',
            flex: '15%',
            height: diagramHeight || 533,
            minWidth: 215,
        };
        return (
            <div id="business_objects_relations" style={{height: "inherit"}}>
                <div id="buttons" className="bo-core-header background-gradient" style={{marginBottom: 5, paddingTop: 10, height: "60px"}}>
                    <div className="custom-select layouts-select" id="custom-select" style={{height: 0, width: 200}}>
                    </div>
                    <button id="delete_layout_btn" style={{marginRight: 2, marginLeft: 2, height: 36, float: "right"}}
                            className="btn btn-danger" onClick={this.deleteLayout}><i
                        className={"fas fa-trash-alt fa-sm"}/> Delete Diagram
                    </button>
                    <button id="save_layout_btn" style={{marginRight: 2, marginLeft: 2, height: 36, float: "right"}}
                            className="btn btn-primary" onClick={this.saveDiagram}><i
                        className={"fas fa-save fa-sm"}/> Save Diagram
                    </button>
                    <button id="save_objects_btn" style={{marginRight: 2, marginLeft: 2, height: 36, float: "right"}}
                            className="btn btn-primary" onClick={this.saveObjects}><i
                        className={"fas fa-save fa-sm"}/> Save Objects
                    </button>
                    <button id="print_diagram_btn" style={{marginRight: 2, marginLeft: 2, height: 36, float: "right"}}
                            className="btn btn-success" onClick={this.printDiagram}><i
                        className={"fas fa-print fa-sm"}/> Print
                    </button>
                    <button id="toggle_link_labels_diagram_btn"
                            style={{marginRight: 2, marginLeft: 2, height: 36, float: "right"}}
                            className="btn btn-success" onClick={this.toggleLabels}><i
                        className={"fas fa-toggle-on fa-sm"}/> Hide Link Labels
                    </button>
                    <button id="auto_layout_btn" style={{marginRight: 2, marginLeft: 2, height: 36, float: "right"}}
                            className="btn btn-success" onClick={this.autoLayout}><i
                        className={"fas fa-project-diagram fa-sm"}/> Auto Diagram
                    </button>
                    <button id="toggle_sys_objects_btn"
                            style={{marginRight: 2, marginLeft: 2, height: 36, float: "right"}}
                            className="btn btn-success" onClick={this.toggleSysObjects}><i
                        className={"fas fa-toggle-on fa-sm"}/> Hide System Objects
                    </button>
                    <button onClick={this.addActiveClass} id="layout-info-popover" rel="popover"
                            style={{float: "right", marginRight: 2, marginLeft: 2, height: 36,}}
                            className="btn btn-lg">
                        <i className="fas fa-info"
                           style={{fontSize: "12px", verticalAlign: "middle", marginBottom: "8px"}}></i>
                    </button>
                </div>
                <div style={{width: 400}} id="popover-content" className="hide">
                    <h4>Buttons</h4>
                    <label style={{marginLeft: 0, marginTop: 5}}>Save Diagram:</label><span> Saves the visible diagram, does not update any objects in the database. You can either create new or update the currently selected diagram.</span><br/>
                    <label style={{marginLeft: 0, marginTop: 5}}>Save Objects:</label><span> Saves the modified business objects and the relationships between them.</span><br/>
                    <label style={{marginLeft: 0, marginTop: 5}}>Delete Diagram:</label><span> Deletes the currently selected diagram.</span><br/>
                    <label style={{marginLeft: 0, marginTop: 5}}>Print:</label><span> Opens a print window with the diagram.</span><br/>
                    <label style={{marginLeft: 0, marginTop: 5}}>Auto Diagram:</label><span> Scatters current visible objects automatically inside the diagram.</span><br/>
                    <br/>
                    <h4>Diagram Guidelines</h4>
                    <span>1:</span><span> You can freely move all circles.</span><br/>
                    <span>2:</span><span> When you select a business object, you have the following options:</span><br/>
                    <span style={{marginLeft: 10}}>a.</span><span> You can draw a link to another business object - click the link button on the first object and then click on the second object to link them.</span><br/>
                    <span style={{marginLeft: 10}}>b.</span><span> You can create a new business object linked to the current business object.</span><br/>
                    <span style={{marginLeft: 10}}>c.</span><span> You can hide the business object from the diagram. (Pressing Delete button from the keyboard also hides the business object.)</span><br/>
                    <span style={{marginLeft: 10}}>d.</span><span> You can delete a business object from the database. To complete the deletion, click Save Objects.</span><br/>
                    <span>3:</span><span> By double clicking anywhere in the free space in the diagram you can create a new business object that is not linked to the others.</span><br/>
                    <span>4:</span> Ctrl + Z - undo changes to the diagram/objects.<br/>
                </div>
                <div id="parent" style={{display: "flex"}}>
                    <div id="diagram" style={{...parentStyle}}>
                        <div id="myDiagramDiv" style={{...diagramStyle}}/>
                        <div style={{border: "solid black", borderWidth: "2px 1px 1px 1px", height: 40, backgroundColor: "#353535"}}>
                            <button title="Zoom In" style={{height: 36, float: "right", margin: 1}}
                                    id="layout_zoom_in_btn"
                                    className="btn btn-lg" onClick={this.zoomIn}>
                                <i className="fas fa-search-plus"
                                   style={{fontSize: "12px", verticalAlign: "middle", marginBottom: "8px"}}></i>
                            </button>
                            <button title="Zoom Out" style={{height: 36, float: "right", margin: 1}}
                                    id="layout_zoom_out_btn"
                                    className="btn btn-lg" onClick={this.zoomOut}>
                                <i className="fas fa-search-minus"
                                   style={{fontSize: "12px", verticalAlign: "middle", marginBottom: "8px"}}></i>
                            </button>
                            <button title="Zoom to Fit" style={{height: 36, float: "right", margin: 1}}
                                    id="layout_zoom_to_fit_btn"
                                    className="btn btn-lg" onClick={this.zoomToFit}>
                                <i className="fas fa-search"
                                   style={{fontSize: "12px", verticalAlign: "middle", marginBottom: "8px"}}></i>
                            </button>
                        </div>
                    </div>
                    <div id="inspectData" style={{...detailStyle}}>
                        <div id="inspector"
                             style={{height: 310, borderBottom: "3px solid black", borderTop: "1px solid black"}}>
                            <div id="nodeInspector" className="inspector"
                                 style={{marginBottom: "20px", margin: "2px"}}/>
                            <div id="linkInspector" className="inspector" style={{margin: "2px"}}/>
                            <button style={{textAlign: "center", margin: 10, width: "100%"}}
                                    id="delete_relationship_btn"
                                    className="btn btn-danger"><i className={"fas fa-trash-alt fa-sm"}/> Delete
                                relationship
                            </button>
                        </div>
                        <div id="bocs_grid" style={{height: 'calc(100% - 310px)'}}>
                            <LayoutBusinessObjectsGrid updateSelected={this.updateSelected.bind(this)}/>
                            <div style={{margin: 1, height: 40}}>
                                <button style={{height: 36, width: "100%"}} id="layout_update_btn"
                                        className="btn btn-warning" disabled><i className={"fas fa-eye fa-sm"}/> Show in
                                    Diagram
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const PopulateLayoutsSelect = (select, dataSource) => {
    let autoLayout = new Option("Full diagram (auto)", JSON.stringify({
        id: -1,
        name: "Full diagram (auto)"
    }));
    select.appendChild(autoLayout);
    let newOption;
    $.each(dataSource, function (value, text) {
        newOption = new Option(text.name, JSON.stringify(text));
        select.appendChild(newOption);
    });
};

const mapStateToProps = (state, ownProps) => {
    return {
        allLayouts: state.boCore.allLayouts,
        currentLayout: state.boCore.currentLayout,
        currentBusinessObject: ownProps.currentBusinessObject,
        businessObjectsWrapper: state.boCore.businessObjectsWrapper,
        hiddenAndModifiedBOCsForLayout: state.boCore.hiddenAndModifiedBOCsForLayout,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setTitle: (title) => {
            dispatch(setTitle(title))
        },
        createLayout: (layout) => {
            dispatch(createBOCLayout(layout));
        },
        fetchAllBOCLayouts: () => {
            dispatch(fetchAllBOCLayouts());
        },
        fetchBOCLayoutById: (id) => {
            dispatch(fetchBOCLayoutById(id));
        },
        setCurrentBOCLayout: (layout) => {
            dispatch(setCurrentBOCLayout(layout));
        },
        deleteBOCLayout: (id) => {
            dispatch(deleteBOCLayout(id));
        },
        updateBOCLayout: (id, layout) => {
            dispatch(updateBOCLayout(id, layout));
        },

        setHiddenAndModifiedBOCsForLayout: (bocs) => {
            dispatch(setHiddenAndModifiedBOCs(bocs));
        },
        layoutSaveObjects: (saveModel) => {
            dispatch(layoutSaveObjects(saveModel));
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(BusinessObjectsLayout)



// WEBPACK FOOTER //
// ./app/views/bo-core/BusinessObjectsLayout.js